import { UPLOADS_BASE, MEDICAL_SPECIALTY_TYPE_OPTIONS, MVT_RELEVANCE_OPTIONS } from "../constants/api";
import { useAdminDashboardCtx } from "../hooks/AdminDashboardContext";
import { filterParentLocations, resolveCountryFieldsFromParent, resolveCountryFlagImagePath } from "../../../utils/locationHelpers";
import {
  SEQUENCE_OPTIONS,
  MASTER_TABLE_REFERENCES,
  formatTableReference,
  IMMUNIZATION_TYPE_OPTIONS,
  APPLICABLE_GENDER_OPTIONS,
  VACCINE_GENDER_OPTIONS,
  APPLICABLE_AGE_GROUP_OPTIONS,
  normalizeEstablishmentTypes,
  normalizeEstablishmentSubTypes,
  filterEstablishmentSubTypes,
  YesNoRadioInline,
  formatYesNo,
  QUESTION_LINKING_OPTIONS,
  QUESTION_LINKING_LABELS,
  getQuestionLinkDisplay,
  PRODUCT_STATUS_OPTIONS,
} from "../forms";

export const MasterListScreen = () => {
  const {
    currentStep,
    setCurrentStep,
    validated,
    setValidated,
    userTypeForm,
    setUserTypeForm,
    userTypes,
    setUserTypes,
    locationTypes,
    setLocationTypes,
    locations,
    setLocations,
    locationTypeForm,
    setLocationTypeForm,
    locationForm,
    setLocationForm,
    specialtyForm,
    setSpecialtyForm,
    estTypeForm,
    setEstTypeForm,
    specialties,
    setSpecialties,
    medicalProcedureForm,
    setMedicalProcedureForm,
    medicalProcedures,
    setMedicalProcedures,
    diseaseForm,
    setDiseaseForm,
    diseases,
    setDiseases,
    symptomCategoryForm,
    setSymptomCategoryForm,
    symptomCategories,
    setSymptomCategories,
    symptomForm,
    setSymptomForm,
    symptoms,
    setSymptoms,
    aggravatingFactorForm,
    setAggravatingFactorForm,
    aggravatingFactors,
    setAggravatingFactors,
    allergyTypeForm,
    setAllergyTypeForm,
    allergyTypes,
    setAllergyTypes,
    allergyForm,
    setAllergyForm,
    allergies,
    setAllergies,
    traumaTypeForm,
    setTraumaTypeForm,
    traumaTypes,
    setTraumaTypes,
    traumaForm,
    setTraumaForm,
    traumas,
    setTraumas,
    addictionCategoryForm,
    setAddictionCategoryForm,
    addictionCategories,
    setAddictionCategories,
    addictionSubCategoryForm,
    setAddictionSubCategoryForm,
    addictionSubCategories,
    setAddictionSubCategories,
    addictionsForm,
    setAddictionsForm,
    addictionsList,
    setAddictionsList,
    patientConditionForm,
    setPatientConditionForm,
    patientConditions,
    setPatientConditions,
    investigationTypeForm,
    setInvestigationTypeForm,
    investigationTypes,
    setInvestigationTypes,
    investigationGroupForm,
    setInvestigationGroupForm,
    investigationGroups,
    setInvestigationGroups,
    investigationForm,
    setInvestigationForm,
    investigations,
    setInvestigations,
    estTypes,
    setEstTypes,
    establishmentSubTypes,
    setEstablishmentSubTypes,
    degreeForm,
    setDegreeForm,
    specializationForm,
    setSpecializationForm,
    degrees,
    setDegrees,
    specializations,
    setSpecializations,
    specializationTypeForm,
    setSpecializationTypeForm,
    specializationTypes,
    setSpecializationTypes,
    accreditationForm,
    setAccreditationForm,
    accreditations,
    setAccreditations,
    departmentCategoryForm,
    setDepartmentCategoryForm,
    departmentCategories,
    setDepartmentCategories,
    departmentForm,
    setDepartmentForm,
    departments,
    setDepartments,
    designationForm,
    setDesignationForm,
    designations,
    setDesignations,
    relationshipForm,
    setRelationshipForm,
    relationships,
    setRelationships,
    bloodGroupForm,
    setBloodGroupForm,
    bloodGroups,
    setBloodGroups,
    therapeuticClassForm,
    setTherapeuticClassForm,
    therapeuticClasses,
    setTherapeuticClasses,
    medicineSaltForm,
    setMedicineSaltForm,
    medicineSalts,
    setMedicineSalts,
    medicalPrescriptionForm,
    setMedicalPrescriptionForm,
    medicalPrescriptions,
    setMedicalPrescriptions,
    medicineDosages,
    setMedicineDosages,
    patientPrescriptionMedicines,
    setPatientPrescriptionMedicines,
    patientCases,
    setPatientCases,
    patientComplaints,
    caseDiagnoses,
    patientInvestigations,
    supplierTypes,
    productCategories,
    productSubCategories,
    products,
    mvtJourneyPhases,
    mvtJourneySteps,
    profileTopicForm,
    setProfileTopicForm,
    profileTopics,
    setProfileTopics,
    profileSubTopicForm,
    setProfileSubTopicForm,
    profileSubTopics,
    setProfileSubTopics,
    serviceTypeForm,
    setServiceTypeForm,
    serviceTypes,
    setServiceTypes,
    medicalServices,
    setMedicalServices,
    serviceForm,
    setServiceForm,
    services,
    setServices,
    questionTypeForm,
    setQuestionTypeForm,
    questionTypes,
    setQuestionTypes,
    questionForm,
    setQuestionForm,
    questions,
    setQuestions,
    optionForm,
    setOptionForm,
    options,
    setOptions,
    questionGroupForm,
    setQuestionGroupForm,
    questionGroups,
    setQuestionGroups,
    establishmentForm,
    setEstablishmentForm,
    establishments,
    setEstablishments,
    doctors,
    setDoctors,
    patients,
    setPatients,
    editingPatientId,
    users,
    setUsers,
    editingUserId,
    setEditingUserId,
    editingDoctorId,
    setEditingDoctorId,
    editingDoctorData,
    setEditingDoctorData,
    eventTypeForm,
    setEventTypeForm,
    eventTypes,
    setEventTypes,
    immunizationForm,
    setImmunizationForm,
    immunizations,
    setImmunizations,
    vaccineForm,
    setVaccineForm,
    vaccines,
    setVaccines,
    loginLogs,
    setLoginLogs,
    editingEstbId,
    setEditingEstbId,
    editingEstbData,
    setEditingEstbData,
    submitMsg,
    setSubmitMsg,
    editingUserTypeId,
    setEditingUserTypeId,
    editingUserTypeValue,
    setEditingUserTypeValue,
    editingTypeId,
    setEditingTypeId,
    editingTypeValue,
    setEditingTypeValue,
    editingLocId,
    setEditingLocId,
    editingLocData,
    setEditingLocData,
    editingSpecId,
    setEditingSpecId,
    editingSpecData,
    setEditingSpecData,
    editingProcId,
    setEditingProcId,
    editingProcData,
    setEditingProcData,
    editingDiseaseId,
    setEditingDiseaseId,
    editingDiseaseData,
    setEditingDiseaseData,
    editingSymptomId,
    setEditingSymptomId,
    editingSymptomData,
    setEditingSymptomData,
    editingAggravatingFactorId,
    setEditingAggravatingFactorId,
    editingAggravatingFactorValue,
    setEditingAggravatingFactorValue,
    editingAllergyTypeId,
    setEditingAllergyTypeId,
    editingAllergyTypeValue,
    setEditingAllergyTypeValue,
    editingAllergyId,
    setEditingAllergyId,
    editingAllergyData,
    setEditingAllergyData,
    editingTraumaTypeId,
    setEditingTraumaTypeId,
    editingTraumaTypeValue,
    setEditingTraumaTypeValue,
    editingTraumaId,
    setEditingTraumaId,
    editingTraumaData,
    setEditingTraumaData,
    editingAddictionCategoryId,
    setEditingAddictionCategoryId,
    editingAddictionCategoryValue,
    setEditingAddictionCategoryValue,
    editingAddictionSubCategoryId,
    setEditingAddictionSubCategoryId,
    editingAddictionSubCategoryData,
    setEditingAddictionSubCategoryData,
    editingAddictionId,
    setEditingAddictionId,
    editingAddictionData,
    setEditingAddictionData,
    editingPatientConditionId,
    setEditingPatientConditionId,
    editingPatientConditionValue,
    setEditingPatientConditionValue,
    editingInvestigationTypeId,
    setEditingInvestigationTypeId,
    editingInvestigationTypeValue,
    setEditingInvestigationTypeValue,
    editingInvestigationGroupId,
    setEditingInvestigationGroupId,
    editingInvestigationGroupData,
    setEditingInvestigationGroupData,
    editingInvestigationId,
    setEditingInvestigationId,
    editingInvestigationData,
    setEditingInvestigationData,
    editingEstId,
    setEditingEstId,
    editingEstValue,
    setEditingEstValue,
    editingEstSubTypeId,
    setEditingEstSubTypeId,
    editingEstSubTypeData,
    setEditingEstSubTypeData,
    editingDegId,
    setEditingDegId,
    editingDegValue,
    setEditingDegValue,
    editingSpeczId,
    setEditingSpeczId,
    editingSpeczData,
    setEditingSpeczData,
    editingSpecTypeId,
    setEditingSpecTypeId,
    editingSpecTypeValue,
    setEditingSpecTypeValue,
    editingAccrId,
    setEditingAccrId,
    editingAccrValue,
    setEditingAccrValue,
    editingDeptCatId,
    setEditingDeptCatId,
    editingDeptCatValue,
    setEditingDeptCatValue,
    editingDeptId,
    setEditingDeptId,
    editingDeptData,
    setEditingDeptData,
    editingDesigId,
    setEditingDesigId,
    editingDesigValue,
    setEditingDesigValue,
    editingRelationshipId,
    setEditingRelationshipId,
    editingRelationshipValue,
    setEditingRelationshipValue,
    editingBloodGroupId,
    setEditingBloodGroupId,
    editingBloodGroupValue,
    setEditingBloodGroupValue,
    editingTherapeuticClassId,
    setEditingTherapeuticClassId,
    editingTherapeuticClassValue,
    setEditingTherapeuticClassValue,
    editingMedicineSaltId,
    setEditingMedicineSaltId,
    editingMedicineSaltData,
    setEditingMedicineSaltData,
    editingMedicalPrescriptionId,
    setEditingMedicalPrescriptionId,
    editingMedicalPrescriptionData,
    setEditingMedicalPrescriptionData,
    editingMedicineDosageId,
    setEditingMedicineDosageId,
    editingMedicineDosageValue,
    setEditingMedicineDosageValue,
    editingPatientPrescriptionMedicineId,
    setEditingPatientPrescriptionMedicineId,
    editingPatientPrescriptionMedicineData,
    setEditingPatientPrescriptionMedicineData,
    editingPatientCaseId,
    setEditingPatientCaseId,
    editingPatientCaseData,
    setEditingPatientCaseData,
    editingPatientComplaintId,
    setEditingPatientComplaintId,
    editingPatientComplaintData,
    setEditingPatientComplaintData,
    editingCaseDiagnosisId,
    setEditingCaseDiagnosisId,
    editingCaseDiagnosisData,
    setEditingCaseDiagnosisData,
    editingPatientInvestigationId,
    setEditingPatientInvestigationId,
    editingPatientInvestigationData,
    setEditingPatientInvestigationData,
    editingProfileTopicId,
    setEditingProfileTopicId,
    editingProfileTopicValue,
    setEditingProfileTopicValue,
    editingProfileSubTopicId,
    setEditingProfileSubTopicId,
    editingProfileSubTopicData,
    setEditingProfileSubTopicData,
    editingServiceTypeId,
    setEditingServiceTypeId,
    editingServiceTypeValue,
    setEditingServiceTypeValue,
    editingMedicalServiceId,
    setEditingMedicalServiceId,
    editingMedicalServiceValue,
    setEditingMedicalServiceValue,
    editingServiceId,
    setEditingServiceId,
    editingServiceData,
    setEditingServiceData,
    editingQuestionTypeId,
    setEditingQuestionTypeId,
    editingQuestionTypeValue,
    setEditingQuestionTypeValue,
    editingQuestionId,
    setEditingQuestionId,
    editingQuestionData,
    setEditingQuestionData,
    editingOptionId,
    setEditingOptionId,
    editingOptionData,
    setEditingOptionData,
    editingQuestionGroupId,
    setEditingQuestionGroupId,
    editingQuestionGroupData,
    setEditingQuestionGroupData,
    editingEventTypeId,
    setEditingEventTypeId,
    editingEventTypeValue,
    setEditingEventTypeValue,
    editingImmunizationId,
    setEditingImmunizationId,
    editingImmunizationData,
    setEditingImmunizationData,
    editingVaccineId,
    setEditingVaccineId,
    editingVaccineData,
    setEditingVaccineData,
    editingSymptomCategoryId,
    setEditingSymptomCategoryId,
    editingSymptomCategoryValue,
    setEditingSymptomCategoryValue,
    editingSupplierTypeId,
    setEditingSupplierTypeId,
    editingSupplierTypeValue,
    setEditingSupplierTypeValue,
    editingProductCategoryId,
    setEditingProductCategoryId,
    editingProductCategoryData,
    setEditingProductCategoryData,
    editingProductSubCategoryId,
    setEditingProductSubCategoryId,
    editingProductSubCategoryData,
    setEditingProductSubCategoryData,
    editingProductId,
    setEditingProductId,
    editingProductData,
    setEditingProductData,
    editingMvtJourneyPhaseId,
    setEditingMvtJourneyPhaseId,
    editingMvtJourneyPhaseValue,
    setEditingMvtJourneyPhaseValue,
    editingMvtJourneyStepId,
    setEditingMvtJourneyStepId,
    editingMvtJourneyStepData,
    setEditingMvtJourneyStepData,
    sidebarOpen,
    setSidebarOpen,
    expandedGroups,
    setExpandedGroups,
    expandedSections,
    setExpandedSections,
    handleLocationTypeChange,
    handleLocationChange,
    handleQuestionFormChange,
    handleEditingQuestionChange,
    makeDeleteHandler,
    handleEditUserType,
    handleSaveUserType,
    handleDeleteUserType,
    handleEditType,
    handleSaveType,
    handleDeleteType,
    handleEditLoc,
    handleSaveLoc,
    handleDeleteLoc,
    handleEditSpec,
    handleSaveSpec,
    handleDeleteSpec,
    handleEditProc,
    handleSaveProc,
    handleDeleteProc,
    handleEditDisease,
    handleSaveDisease,
    handleDeleteDisease,
    handleEditEst,
    handleSaveEst,
    handleDeleteEst,
    handleEditEstSubType,
    handleSaveEstSubType,
    handleDeleteEstSubType,
    handleEditDeg,
    handleSaveDeg,
    handleDeleteDeg,
    handleEditSpecz,
    handleSaveSpecz,
    handleDeleteSpecz,
    handleEditSpecType,
    handleSaveSpecType,
    handleDeleteSpecType,
    handleEditAccr,
    handleSaveAccr,
    handleDeleteAccr,
    handleEditDeptCat,
    handleSaveDeptCat,
    handleDeleteDeptCat,
    handleEditDept,
    handleSaveDept,
    handleDeleteDept,
    handleEditDesig,
    handleSaveDesig,
    handleDeleteDesig,
    handleEditRelationship,
    handleSaveRelationship,
    handleDeleteRelationship,
    handleEditBloodGroup,
    handleSaveBloodGroup,
    handleDeleteBloodGroup,
    handleEditTherapeuticClass,
    handleSaveTherapeuticClass,
    handleDeleteTherapeuticClass,
    handleEditMedicineSalt,
    handleSaveMedicineSalt,
    handleDeleteMedicineSalt,
    handleEditMedicalPrescription,
    handleSaveMedicalPrescription,
    handleDeleteMedicalPrescription,
    handleEditMedicineDosage,
    handleSaveMedicineDosage,
    handleDeleteMedicineDosage,
    handleEditPatientPrescriptionMedicine,
    handleSavePatientPrescriptionMedicine,
    handleDeletePatientPrescriptionMedicine,
    handleEditPatientCase,
    handleSavePatientCase,
    handleDeletePatientCase,
    handleEditPatientComplaint,
    handleSavePatientComplaint,
    handleDeletePatientComplaint,
    handleEditCaseDiagnosis,
    handleSaveCaseDiagnosis,
    handleDeleteCaseDiagnosis,
    handleEditPatientInvestigation,
    handleSavePatientInvestigation,
    handleDeletePatientInvestigation,
    handleEditSupplierType,
    handleSaveSupplierType,
    handleDeleteSupplierType,
    handleEditProductCategory,
    handleSaveProductCategory,
    handleDeleteProductCategory,
    handleEditProductSubCategory,
    handleSaveProductSubCategory,
    handleDeleteProductSubCategory,
    handleEditProduct,
    handleSaveProduct,
    handleDeleteProduct,
    handleEditMvtJourneyPhase,
    handleSaveMvtJourneyPhase,
    handleDeleteMvtJourneyPhase,
    handleEditMvtJourneyStep,
    handleSaveMvtJourneyStep,
    handleDeleteMvtJourneyStep,
    handleEditProfileTopic,
    handleSaveProfileTopic,
    handleDeleteProfileTopic,
    handleEditProfileSubTopic,
    handleSaveProfileSubTopic,
    handleDeleteProfileSubTopic,
    handleEditServiceType,
    handleSaveServiceType,
    handleDeleteServiceType,
    handleEditMedicalService,
    handleSaveMedicalService,
    handleDeleteMedicalService,
    handleEditService,
    handleSaveService,
    handleDeleteService,
    handleEditQuestionType,
    handleSaveQuestionType,
    handleDeleteQuestionType,
    handleEditQuestion,
    handleSaveQuestion,
    handleDeleteQuestion,
    handleEditOption,
    handleSaveOption,
    handleDeleteOption,
    handleEditQuestionGroup,
    handleSaveQuestionGroup,
    handleDeleteQuestionGroup,
    handleEditAggravatingFactor,
    handleSaveAggravatingFactor,
    handleDeleteAggravatingFactor,
    handleEditAllergyType,
    handleSaveAllergyType,
    handleDeleteAllergyType,
    handleEditAllergy,
    handleSaveAllergy,
    handleDeleteAllergy,
    handleEditTraumaType,
    handleSaveTraumaType,
    handleDeleteTraumaType,
    handleEditTrauma,
    handleSaveTrauma,
    handleDeleteTrauma,
    handleEditAddictionCategory,
    handleSaveAddictionCategory,
    handleDeleteAddictionCategory,
    handleEditAddictionSubCategory,
    handleSaveAddictionSubCategory,
    handleDeleteAddictionSubCategory,
    handleEditAddiction,
    handleSaveAddiction,
    handleDeleteAddiction,
    handleEditPatientCondition,
    handleSavePatientCondition,
    handleDeletePatientCondition,
    handleEditInvestigationType,
    handleSaveInvestigationType,
    handleDeleteInvestigationType,
    handleEditInvestigationGroup,
    handleSaveInvestigationGroup,
    handleDeleteInvestigationGroup,
    handleEditInvestigation,
    handleSaveInvestigation,
    handleDeleteInvestigation,
    handleEditSymptomCategory,
    handleSaveSymptomCategory,
    handleDeleteSymptomCategory,
    handleEditSymptom,
    handleSaveSymptom,
    handleDeleteSymptom,
    handleEditEstb,
    handleSaveEstb,
    handleDeleteEstb,
    handleOpenCreateLogin,
    handleEditDoctor,
    handleSaveDoctor,
    handleDeleteDoctor,
    handleOpenCreateDoctorLogin,
    handleEditPatient,
    handleCancelPatientEdit,
    handleDeletePatient,
    handleEditUser,
    handleDeleteUser,
    handleOpenCreateUserLogin,
    handleEditEventType,
    handleSaveEventType,
    handleDeleteEventType,
    handleEditImmunization,
    handleSaveImmunization,
    handleDeleteImmunization,
    handleEditVaccine,
    handleSaveVaccine,
    handleDeleteVaccine,
    handleSubmit,
    renderForm,
    toggleMenuGroup,
    toggleMenuSection,
    selectStep,
    STEPS,
    STEP_DESCRIPTIONS,
    MENU_GROUPS,
    getGroupSteps,
    API_BASE,
    UPLOADS_BASE,
    formatDateTime,
    formatProcCostUsd,
    formatProcCostInr,
    parseImagePaths,
    getMorbidityDiseases,
    morbidityDiseases,
  } = useAdminDashboardCtx();

  return (
    <>
              {currentStep === 40 && (
                <div className="authdata-listview authdata-listview--standalone">
                  <h6 className="authdata-listview-title">User Login History</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Login ID</th>
                          <th>User Type</th>
                          <th>Login Time</th>
                          <th>Logout Time</th>
                          <th>Status</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loginLogs.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="authdata-empty-row">
                              No login records found.
                            </td>
                          </tr>
                        ) : (
                          loginLogs.map((log, i) => (
                            <tr key={log.log_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Login ID">{log.login_id}</td>
                              <td data-label="User Type">{log.user_type || "—"}</td>
                              <td data-label="Login Time">{formatDateTime(log.login_datetime)}</td>
                              <td data-label="Logout Time">{formatDateTime(log.logout_datetime)}</td>
                              <td data-label="Status">
                                <span className={`authdata-status authdata-status--${(log.status || "").toLowerCase()}`}>
                                  {log.status}
                                </span>
                              </td>
                              <td data-label="Location">{log.location || "—"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {submitMsg && (
                <div
                  className={`authdata-msg ${submitMsg.startsWith("Error") ? "error" : "success"}`}
                >
                  {submitMsg}
                </div>
              )}

              {/* List view — User Type Master */}
              {currentStep === 0 && userTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved User Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>User Type ID</th>
                          <th>User Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userTypes.map((ut, i) => (
                          <tr key={ut.user_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="User Type ID">{ut.user_type_id}</td>
                            <td data-label="User Type">
                              {editingUserTypeId === ut.user_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingUserTypeValue}
                                  onChange={(e) => setEditingUserTypeValue(e.target.value)}
                                />
                              ) : ut.user_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingUserTypeId === ut.user_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveUserType(ut.user_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingUserTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditUserType(ut)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteUserType(ut.user_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Location Type Master */}
              {currentStep === 1 && locationTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Location Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Location Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {locationTypes.map((lt, i) => (
                          <tr key={lt.location_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Location Type">
                              {editingTypeId === lt.location_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingTypeValue}
                                  onChange={(e) => setEditingTypeValue(e.target.value)}
                                />
                              ) : lt.location_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingTypeId === lt.location_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveType(lt.location_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditType(lt)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteType(lt.location_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Location Master */}
              {currentStep === 2 && locations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Locations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th><th>Location Name</th><th>Location Type</th><th>Parent</th><th>Location Category</th><th>Country Code</th><th>Treatment Cost Currency</th><th>Local Currency</th><th>Icon Image</th><th>Country Flag Image</th><th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {locations.map((loc, i) => {
                          const typeName = locationTypes.find((lt) => lt.location_type_id === Number(loc.location_type_id))?.location_type || loc.location_type || "—";
                          const parentName = locations.find((l) => l.location_id === Number(loc.parent_location_id))?.location_name || "—";
                          const isEditing = editingLocId === loc.location_id;
                          const parentLocations = filterParentLocations(
                            locations,
                            locationTypes,
                            editingLocData.location_type_id
                          ).filter((location) => location.location_id !== loc.location_id);
                          const flagImagePath = resolveCountryFlagImagePath(locations, isEditing ? editingLocData : loc);
                          const isChildEditing = !!(isEditing && editingLocData.parent_location_id);
                          const currencyOptions = ["USD", "INR", "EUR"];
                          return (
                            <tr key={loc.location_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Location Name">{isEditing ? <input className="authdata-inline-input" value={editingLocData.location_name || ""} onChange={(e) => setEditingLocData((p) => ({ ...p, location_name: e.target.value }))} /> : loc.location_name}</td>
                              <td data-label="Location Type">{isEditing ? <select className="authdata-inline-input" value={editingLocData.location_type_id || ""} onChange={(e) => setEditingLocData((p) => ({ ...p, location_type_id: e.target.value, parent_location_id: "", country_code: "", country_flag_image_path: "", country_flag_image: null, treatment_cost_currency: "", local_currency: "" }))}>{locationTypes.map((lt) => <option key={lt.location_type_id} value={lt.location_type_id}>{lt.location_type}</option>)}</select> : typeName}</td>
                              <td data-label="Parent">{isEditing ? <select className="authdata-inline-input" value={editingLocData.parent_location_id || ""} onChange={(e) => {
                                const parentId = e.target.value;
                                setEditingLocData((p) => {
                                  const updated = { ...p, parent_location_id: parentId };
                                  if (parentId) {
                                    const inherited = resolveCountryFieldsFromParent(locations, parentId);
                                    if (inherited.country_code) updated.country_code = inherited.country_code;
                                    if (inherited.country_flag_image_path) updated.country_flag_image_path = inherited.country_flag_image_path;
                                    if (inherited.treatment_cost_currency) updated.treatment_cost_currency = inherited.treatment_cost_currency;
                                    if (inherited.local_currency) updated.local_currency = inherited.local_currency;
                                    updated.country_flag_image = null;
                                  } else {
                                    updated.country_code = "";
                                    updated.country_flag_image_path = "";
                                    updated.country_flag_image = null;
                                    updated.treatment_cost_currency = "";
                                    updated.local_currency = "";
                                  }
                                  return updated;
                                });
                              }}><option value="">None</option>{parentLocations.map((l) => <option key={l.location_id} value={l.location_id}>{l.location_name}</option>)}</select> : parentName}</td>
                              <td data-label="Location Category">{isEditing ? <select className="authdata-inline-input" value={editingLocData.location_category || ""} onChange={(e) => setEditingLocData((p) => ({ ...p, location_category: e.target.value }))}><option value="">Select category</option><option value="Referral Location">Referral Location</option><option value="Treatment Location">Treatment Location</option></select> : (loc.location_category || "—")}</td>
                              <td data-label="Country Code">{isEditing ? <input className="authdata-inline-input" value={editingLocData.country_code || ""} maxLength={10} readOnly={isChildEditing} onChange={(e) => setEditingLocData((p) => ({ ...p, country_code: e.target.value }))} /> : (loc.country_code || "—")}</td>
                              <td data-label="Treatment Cost Currency">{isEditing ? <select className="authdata-inline-input" value={editingLocData.treatment_cost_currency || ""} disabled={isChildEditing} onChange={(e) => setEditingLocData((p) => ({ ...p, treatment_cost_currency: e.target.value }))}><option value="">Select</option>{currencyOptions.map((c) => <option key={c} value={c}>{c}</option>)}</select> : (loc.treatment_cost_currency || "—")}</td>
                              <td data-label="Local Currency">{isEditing ? <select className="authdata-inline-input" value={editingLocData.local_currency || ""} disabled={isChildEditing} onChange={(e) => setEditingLocData((p) => ({ ...p, local_currency: e.target.value }))}><option value="">Select</option>{currencyOptions.map((c) => <option key={c} value={c}>{c}</option>)}</select> : (loc.local_currency || "—")}</td>
                              <td data-label="Icon Image">
                                {isEditing ? (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="authdata-inline-input"
                                    onChange={(e) => setEditingLocData((p) => ({ ...p, icon_image: e.target.files[0] }))}
                                  />
                                ) : loc.icon_image_path ? (
                                  <img
                                    src={`${UPLOADS_BASE}/uploads/${loc.icon_image_path}`}
                                    alt={loc.location_name}
                                    style={{ maxWidth: 48, maxHeight: 48, objectFit: "contain" }}
                                  />
                                ) : "—"}
                              </td>
                              <td data-label="Country Flag Image">
                                {isEditing ? (
                                  editingLocData.parent_location_id ? (
                                    flagImagePath ? (
                                      <img
                                        src={`${UPLOADS_BASE}/uploads/${flagImagePath}`}
                                        alt="Country flag"
                                        style={{ maxWidth: 48, maxHeight: 48, objectFit: "contain" }}
                                      />
                                    ) : "—"
                                  ) : (
                                    <input
                                      type="file"
                                      accept="image/*"
                                      className="authdata-inline-input"
                                      onChange={(e) => setEditingLocData((p) => ({ ...p, country_flag_image: e.target.files[0] }))}
                                    />
                                  )
                                ) : flagImagePath ? (
                                  <img
                                    src={`${UPLOADS_BASE}/uploads/${flagImagePath}`}
                                    alt={`${loc.location_name} flag`}
                                    style={{ maxWidth: 48, maxHeight: 48, objectFit: "contain" }}
                                  />
                                ) : "—"}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <><button type="button" className="btn-action save" onClick={() => handleSaveLoc(loc.location_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingLocId(null)}>Cancel</button></>
                                ) : (
                                  <><button type="button" className="btn-action edit" onClick={() => handleEditLoc(loc)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteLoc(loc.location_id)}>Delete</button></>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medical Specialty Master */}
              {currentStep === 3 && specialties.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medical Specialties</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Medical Specialty</th>
                          <th>Specialty Type</th>
                          <th>MVT Relevance</th>
                          <th>Icon Image</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {specialties.map((s, i) => {
                          const isEditing = editingSpecId === s.medical_specialty_id;
                          return (
                            <tr key={s.medical_specialty_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Medical Specialty">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingSpecData.medical_specialty || ""}
                                    onChange={(e) => setEditingSpecData((p) => ({ ...p, medical_specialty: e.target.value }))}
                                  />
                                ) : s.medical_specialty}
                              </td>
                              <td data-label="Specialty Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingSpecData.medical_specialty_type || ""}
                                    onChange={(e) => setEditingSpecData((p) => ({ ...p, medical_specialty_type: e.target.value }))}
                                  >
                                    <option value="">Select type</option>
                                    {MEDICAL_SPECIALTY_TYPE_OPTIONS.map((t) => (
                                      <option key={t} value={t}>{t}</option>
                                    ))}
                                  </select>
                                ) : (s.medical_specialty_type || "—")}
                              </td>
                              <td data-label="MVT Relevance">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingSpecData.mvt_relevance || "No"}
                                    onChange={(e) => setEditingSpecData((p) => ({ ...p, mvt_relevance: e.target.value }))}
                                  >
                                    {MVT_RELEVANCE_OPTIONS.map((opt) => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                ) : (s.mvt_relevance || "No")}
                              </td>
                              <td data-label="Icon Image">
                                {isEditing ? (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="authdata-inline-input"
                                    onChange={(e) => setEditingSpecData((p) => ({ ...p, icon_image: e.target.files[0] }))}
                                  />
                                ) : s.icon_image_path ? (
                                  <img
                                    src={`${UPLOADS_BASE}/uploads/${s.icon_image_path}`}
                                    alt={s.medical_specialty}
                                    style={{ maxWidth: 48, maxHeight: 48, objectFit: "contain" }}
                                  />
                                ) : "—"}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveSpec(s.medical_specialty_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingSpecId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditSpec(s)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteSpec(s.medical_specialty_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medical Procedure Master */}
              {currentStep === 4 && medicalProcedures.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medical Procedures</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Medical Specialty</th>
                          <th>Procedure ID</th>
                          <th>Procedure Name</th>
                          <th>Alternate Name</th>
                          <th>Surgical Approach</th>
                          <th>Complexity Level</th>
                          <th>ICD-10-PCS Code</th>
                          <th>CPT Reference Code</th>
                          <th>Clinical Notes</th>
                          <th>Past Surgery Relevance</th>
                          <th>MVT Relevance</th>
                          <th>Est. Cost (USD)</th>
                          <th>Est. Cost (INR)</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medicalProcedures.map((p, i) => {
                          const isEditing = editingProcId === p.procedure_id;
                          const specialtyName = p.medical_specialty
                            || specialties.find(
                              (s) => String(s.medical_specialty_id) === String(p.medical_specialty_id)
                            )?.medical_specialty
                            || "—";
                          const inp = (field) => (
                            <input
                              className="authdata-inline-input"
                              value={editingProcData[field] || ""}
                              onChange={(e) => setEditingProcData((prev) => ({ ...prev, [field]: e.target.value }))}
                            />
                          );
                          const costInp = (field) => (
                            <input
                              className="authdata-inline-input"
                              type="number"
                              min="0"
                              step="0.01"
                              value={editingProcData[field] ?? ""}
                              onChange={(e) => setEditingProcData((prev) => ({ ...prev, [field]: e.target.value }))}
                            />
                          );
                          const yesNoEdit = (field) => (
                            <YesNoRadioInline
                              name={`proc-${p.procedure_id}-${field}`}
                              value={editingProcData[field]}
                              onChange={(v) => setEditingProcData((prev) => ({ ...prev, [field]: v }))}
                            />
                          );
                          return (
                            <tr key={p.procedure_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Medical Specialty">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProcData.medical_specialty_id || ""}
                                    onChange={(e) => setEditingProcData((prev) => ({ ...prev, medical_specialty_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {specialties.map((s) => (
                                      <option key={s.medical_specialty_id} value={s.medical_specialty_id}>
                                        {s.medical_specialty}
                                      </option>
                                    ))}
                                  </select>
                                ) : specialtyName}
                              </td>
                              <td data-label="Procedure ID">{p.procedure_id}</td>
                              <td data-label="Procedure Name">{isEditing ? inp("procedure_name") : p.procedure_name}</td>
                              <td data-label="Alternate Name">{isEditing ? inp("alternate_name") : (p.alternate_name || "—")}</td>
                              <td data-label="Surgical Approach">{isEditing ? inp("surgical_approach") : (p.surgical_approach || "—")}</td>
                              <td data-label="Complexity Level">{isEditing ? inp("complexity_level") : (p.complexity_level || "—")}</td>
                              <td data-label="ICD-10-PCS Code">{isEditing ? inp("icd10_pcs_code") : (p.icd10_pcs_code || "—")}</td>
                              <td data-label="CPT Reference Code">{isEditing ? inp("cpt_reference_code") : (p.cpt_reference_code || "—")}</td>
                              <td data-label="Clinical Notes">{isEditing ? inp("clinical_notes") : (p.clinical_notes || "—")}</td>
                              <td data-label="Past Surgery Relevance">
                                {isEditing
                                  ? yesNoEdit("past_surgery_relevance")
                                  : formatYesNo(p.past_surgery_relevance)}
                              </td>
                              <td data-label="MVT Relevance">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProcData.mvt_relevance || "No"}
                                    onChange={(e) => setEditingProcData((prev) => ({ ...prev, mvt_relevance: e.target.value }))}
                                  >
                                    {MVT_RELEVANCE_OPTIONS.map((opt) => (
                                      <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                  </select>
                                ) : (p.mvt_relevance || "No")}
                              </td>
                              <td data-label="Est. Cost (USD)">
                                {isEditing ? (
                                  <div className="d-flex flex-column gap-1">
                                    {costInp("est_cost_usd_low")}
                                    {costInp("est_cost_usd_high")}
                                  </div>
                                ) : formatProcCostUsd(p.est_cost_usd_low, p.est_cost_usd_high)}
                              </td>
                              <td data-label="Est. Cost (INR)">
                                {isEditing ? (
                                  <div className="d-flex flex-column gap-1">
                                    {costInp("est_cost_inr_low")}
                                    {costInp("est_cost_inr_high")}
                                  </div>
                                ) : formatProcCostInr(p.est_cost_inr_low, p.est_cost_inr_high)}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveProc(p.procedure_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingProcId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditProc(p)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteProc(p.procedure_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Disease Master */}
              {currentStep === 5 && diseases.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Diseases</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Medical Specialty</th>
                          <th>Disease Name</th>
                          <th>Description</th>
                          <th>Comorbidity</th>
                          <th>Family History</th>
                          <th>Past Illness</th>
                          <th>ICD10 Code</th>
                          <th>ICD11 Code</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {diseases.map((d, i) => {
                          const isEditing = editingDiseaseId === d.disease_id;
                          const specialtyName = d.medical_specialty
                            || specialties.find(
                              (s) => String(s.medical_specialty_id) === String(d.medical_specialty_id)
                            )?.medical_specialty
                            || "—";
                          const inp = (field) => (
                            <input
                              className="authdata-inline-input"
                              value={editingDiseaseData[field] || ""}
                              onChange={(e) => setEditingDiseaseData((p) => ({ ...p, [field]: e.target.value }))}
                            />
                          );
                          const yesNoEdit = (field) => (
                            <YesNoRadioInline
                              name={`edit-${d.disease_id}-${field}`}
                              value={editingDiseaseData[field]}
                              onChange={(v) => setEditingDiseaseData((p) => ({ ...p, [field]: v }))}
                            />
                          );
                          return (
                            <tr key={d.disease_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Medical Specialty">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingDiseaseData.medical_specialty_id || ""}
                                    onChange={(e) => setEditingDiseaseData((p) => ({ ...p, medical_specialty_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {specialties.map((s) => (
                                      <option key={s.medical_specialty_id} value={s.medical_specialty_id}>
                                        {s.medical_specialty}
                                      </option>
                                    ))}
                                  </select>
                                ) : specialtyName}
                              </td>
                              <td data-label="Disease Name">{isEditing ? inp("disease_name") : d.disease_name}</td>
                              <td data-label="Description">{isEditing ? inp("description") : (d.description || "—")}</td>
                              <td data-label="Comorbidity">{isEditing ? yesNoEdit("comorbidity_disease") : formatYesNo(d.comorbidity_disease)}</td>
                              <td data-label="Family History">{isEditing ? yesNoEdit("family_history_disease") : formatYesNo(d.family_history_disease)}</td>
                              <td data-label="Past Illness">{isEditing ? yesNoEdit("past_illness_disease") : formatYesNo(d.past_illness_disease)}</td>
                              <td data-label="ICD10 Code">{isEditing ? inp("icd10_code") : (d.icd10_code || "—")}</td>
                              <td data-label="ICD11 Code">{isEditing ? inp("icd11_code") : (d.icd11_code || "—")}</td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveDisease(d.disease_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingDiseaseId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditDisease(d)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteDisease(d.disease_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Symptom Category Master */}
              {currentStep === 6 && symptomCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Symptom Categories</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Symptom Category</th><th>Actions</th></tr></thead>
                      <tbody>
                        {symptomCategories.map((sc, i) => (
                          <tr key={sc.symptom_category_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Symptom Category">
                              {editingSymptomCategoryId === sc.symptom_category_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingSymptomCategoryValue}
                                  onChange={(e) => setEditingSymptomCategoryValue(e.target.value)}
                                />
                              ) : sc.symptom_category}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingSymptomCategoryId === sc.symptom_category_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveSymptomCategory(sc.symptom_category_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingSymptomCategoryId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditSymptomCategory(sc)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteSymptomCategory(sc.symptom_category_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Symptom Master */}
              {currentStep === 7 && symptoms.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Symptoms</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Symptom Category</th>
                          <th>Symptom Name</th>
                          <th>Common Name</th>
                          <th>Severity Level</th>
                          <th>Acute / Chronic</th>
                          <th>Body System</th>
                          <th>ICD-10 Reference</th>
                          <th>Clinical Notes</th>
                          <th>Description</th>
                          <th>Picture</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {symptoms.map((s, i) => {
                          const isEditing = editingSymptomId === s.symptom_id;
                          const categoryName = s.symptom_category
                            || symptomCategories.find(
                              (sc) => String(sc.symptom_category_id) === String(s.symptom_category_id)
                            )?.symptom_category
                            || "—";
                          const inp = (field) => (
                            <input
                              className="authdata-inline-input"
                              value={editingSymptomData[field] || ""}
                              onChange={(e) => setEditingSymptomData((p) => ({ ...p, [field]: e.target.value }))}
                            />
                          );
                          return (
                            <tr key={s.symptom_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Symptom Category">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingSymptomData.symptom_category_id || ""}
                                    onChange={(e) => setEditingSymptomData((p) => ({ ...p, symptom_category_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {symptomCategories.map((sc) => (
                                      <option key={sc.symptom_category_id} value={sc.symptom_category_id}>
                                        {sc.symptom_category}
                                      </option>
                                    ))}
                                  </select>
                                ) : categoryName}
                              </td>
                              <td data-label="Symptom Name">{isEditing ? inp("symptom_name") : s.symptom_name}</td>
                              <td data-label="Common Name">{isEditing ? inp("common_name") : (s.common_name || "—")}</td>
                              <td data-label="Severity Level">{isEditing ? inp("severity_level") : (s.severity_level || "—")}</td>
                              <td data-label="Acute / Chronic">{isEditing ? inp("acute_chronic") : (s.acute_chronic || "—")}</td>
                              <td data-label="Body System">{isEditing ? inp("body_system") : (s.body_system || "—")}</td>
                              <td data-label="ICD-10 Reference">{isEditing ? inp("icd10_reference") : (s.icd10_reference || "—")}</td>
                              <td data-label="Clinical Notes">{isEditing ? inp("clinical_notes") : (s.clinical_notes || "—")}</td>
                              <td data-label="Description">{isEditing ? inp("description") : (s.description || "—")}</td>
                              <td data-label="Picture">
                                {isEditing ? (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setEditingSymptomData((p) => ({ ...p, picture: e.target.files[0] }))}
                                  />
                                ) : s.picture_path ? (
                                  <img
                                    src={`${UPLOADS_BASE}/uploads/${s.picture_path}`}
                                    alt={s.symptom_name}
                                    style={{ maxHeight: 40, maxWidth: 80, objectFit: "contain" }}
                                  />
                                ) : "—"}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveSymptom(s.symptom_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingSymptomId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditSymptom(s)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteSymptom(s.symptom_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Aggravating Factor Master */}
              {currentStep === 8 && aggravatingFactors.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Aggravating Factors</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Aggravating Factor</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aggravatingFactors.map((af, i) => (
                          <tr key={af.aggravating_factor_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Aggravating Factor">
                              {editingAggravatingFactorId === af.aggravating_factor_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingAggravatingFactorValue}
                                  onChange={(e) => setEditingAggravatingFactorValue(e.target.value)}
                                />
                              ) : af.aggravating_factor}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingAggravatingFactorId === af.aggravating_factor_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveAggravatingFactor(af.aggravating_factor_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingAggravatingFactorId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditAggravatingFactor(af)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteAggravatingFactor(af.aggravating_factor_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Allergy Type Master */}
              {currentStep === 9 && allergyTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Allergy Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Allergy Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allergyTypes.map((at, i) => (
                          <tr key={at.allergy_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Allergy Type">
                              {editingAllergyTypeId === at.allergy_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingAllergyTypeValue}
                                  onChange={(e) => setEditingAllergyTypeValue(e.target.value)}
                                />
                              ) : at.allergy_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingAllergyTypeId === at.allergy_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveAllergyType(at.allergy_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingAllergyTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditAllergyType(at)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteAllergyType(at.allergy_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Allergy Master */}
              {currentStep === 10 && allergies.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Allergies</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Allergy Type</th>
                          <th>Allergy</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allergies.map((a, i) => {
                          const isEditing = editingAllergyId === a.allergy_id;
                          const typeName = a.allergy_type
                            || allergyTypes.find(
                              (at) => String(at.allergy_type_id) === String(a.allergy_type_id)
                            )?.allergy_type
                            || "—";
                          return (
                            <tr key={a.allergy_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Allergy Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingAllergyData.allergy_type_id || ""}
                                    onChange={(e) => setEditingAllergyData((p) => ({ ...p, allergy_type_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {allergyTypes.map((at) => (
                                      <option key={at.allergy_type_id} value={at.allergy_type_id}>
                                        {at.allergy_type}
                                      </option>
                                    ))}
                                  </select>
                                ) : typeName}
                              </td>
                              <td data-label="Allergy">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingAllergyData.allergy || ""}
                                    onChange={(e) => setEditingAllergyData((p) => ({ ...p, allergy: e.target.value }))}
                                  />
                                ) : a.allergy}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveAllergy(a.allergy_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingAllergyId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditAllergy(a)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteAllergy(a.allergy_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Trauma Type Master */}
              {currentStep === 11 && traumaTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Trauma Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Trauma Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {traumaTypes.map((tt, i) => (
                          <tr key={tt.trauma_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Trauma Type">
                              {editingTraumaTypeId === tt.trauma_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingTraumaTypeValue}
                                  onChange={(e) => setEditingTraumaTypeValue(e.target.value)}
                                />
                              ) : tt.trauma_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingTraumaTypeId === tt.trauma_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveTraumaType(tt.trauma_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingTraumaTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditTraumaType(tt)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteTraumaType(tt.trauma_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Trauma Master */}
              {currentStep === 12 && traumas.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Traumas</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Trauma Type</th><th>Trauma Name</th><th>Actions</th></tr></thead>
                      <tbody>
                        {traumas.map((t, i) => {
                          const isEditing = editingTraumaId === t.trauma_id;
                          const typeName = t.trauma_type || traumaTypes.find((tt) => String(tt.trauma_type_id) === String(t.trauma_type_id))?.trauma_type || "—";
                          return (
                            <tr key={t.trauma_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Trauma Type">
                                {isEditing ? (
                                  <select className="authdata-inline-input" value={editingTraumaData.trauma_type_id || ""} onChange={(e) => setEditingTraumaData((p) => ({ ...p, trauma_type_id: e.target.value }))}>
                                    <option value="">Select</option>
                                    {traumaTypes.map((tt) => <option key={tt.trauma_type_id} value={tt.trauma_type_id}>{tt.trauma_type}</option>)}
                                  </select>
                                ) : typeName}
                              </td>
                              <td data-label="Trauma Name">{isEditing ? <input className="authdata-inline-input" value={editingTraumaData.trauma_name || ""} onChange={(e) => setEditingTraumaData((p) => ({ ...p, trauma_name: e.target.value }))} /> : t.trauma_name}</td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (<><button type="button" className="btn-action save" onClick={() => handleSaveTrauma(t.trauma_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingTraumaId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditTrauma(t)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteTrauma(t.trauma_id)}>Delete</button></>)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Addiction Category Master */}
              {currentStep === 13 && addictionCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Addiction Categories</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Addiction Category ID</th><th>Addiction Category</th><th>Actions</th></tr></thead>
                      <tbody>
                        {addictionCategories.map((ac, i) => (
                          <tr key={ac.addiction_category_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Addiction Category ID">{ac.addiction_category_id}</td>
                            <td data-label="Addiction Category">{editingAddictionCategoryId === ac.addiction_category_id ? <input className="authdata-inline-input" value={editingAddictionCategoryValue} onChange={(e) => setEditingAddictionCategoryValue(e.target.value)} /> : ac.addiction_category}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingAddictionCategoryId === ac.addiction_category_id ? (<><button type="button" className="btn-action save" onClick={() => handleSaveAddictionCategory(ac.addiction_category_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingAddictionCategoryId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditAddictionCategory(ac)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteAddictionCategory(ac.addiction_category_id)}>Delete</button></>)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Addiction Sub Category Master */}
              {currentStep === 14 && addictionSubCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Addiction Sub Categories</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Addiction Sub Category ID</th>
                          <th>Addiction Category</th>
                          <th>Addiction Sub Category</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addictionSubCategories.map((sc, i) => {
                          const isEditing = editingAddictionSubCategoryId === sc.addiction_sub_category_id;
                          const categoryName = sc.addiction_category
                            || addictionCategories.find(
                              (ac) => String(ac.addiction_category_id) === String(sc.addiction_category_id)
                            )?.addiction_category
                            || "—";
                          return (
                            <tr key={sc.addiction_sub_category_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Addiction Sub Category ID">{sc.addiction_sub_category_id}</td>
                              <td data-label="Addiction Category">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingAddictionSubCategoryData.addiction_category_id || ""}
                                    onChange={(e) => setEditingAddictionSubCategoryData((p) => ({ ...p, addiction_category_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {addictionCategories.map((ac) => (
                                      <option key={ac.addiction_category_id} value={ac.addiction_category_id}>{ac.addiction_category}</option>
                                    ))}
                                  </select>
                                ) : categoryName}
                              </td>
                              <td data-label="Addiction Sub Category">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingAddictionSubCategoryData.addiction_sub_category || ""}
                                    onChange={(e) => setEditingAddictionSubCategoryData((p) => ({ ...p, addiction_sub_category: e.target.value }))}
                                  />
                                ) : sc.addiction_sub_category}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveAddictionSubCategory(sc.addiction_sub_category_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingAddictionSubCategoryId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditAddictionSubCategory(sc)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteAddictionSubCategory(sc.addiction_sub_category_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Addiction Master */}
              {currentStep === 15 && addictionsList.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Addictions</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Addiction Category</th>
                          <th>Addiction Sub Category</th>
                          <th>Addiction</th>
                          <th>Description</th>
                          <th>Clinical Classification</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addictionsList.map((a, i) => {
                          const isEditing = editingAddictionId === a.addictions_id;
                          const categoryName = a.addiction_category || addictionCategories.find((ac) => String(ac.addiction_category_id) === String(a.addiction_category_id))?.addiction_category || "—";
                          const subCategoryName = a.addiction_sub_category || addictionSubCategories.find((sc) => String(sc.addiction_sub_category_id) === String(a.addiction_sub_category_id))?.addiction_sub_category || "—";
                          const filteredSubCategories = addictionSubCategories.filter(
                            (sc) => String(sc.addiction_category_id) === String(isEditing ? editingAddictionData.addiction_category_id : a.addiction_category_id)
                          );
                          return (
                            <tr key={a.addictions_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Addiction Category">{isEditing ? (
                                <select
                                  className="authdata-inline-input"
                                  value={editingAddictionData.addiction_category_id || ""}
                                  onChange={(e) => setEditingAddictionData((p) => ({ ...p, addiction_category_id: e.target.value, addiction_sub_category_id: "" }))}
                                >
                                  <option value="">Select</option>
                                  {addictionCategories.map((ac) => <option key={ac.addiction_category_id} value={ac.addiction_category_id}>{ac.addiction_category}</option>)}
                                </select>
                              ) : categoryName}</td>
                              <td data-label="Addiction Sub Category">{isEditing ? (
                                <select
                                  className="authdata-inline-input"
                                  value={editingAddictionData.addiction_sub_category_id || ""}
                                  onChange={(e) => setEditingAddictionData((p) => ({ ...p, addiction_sub_category_id: e.target.value }))}
                                >
                                  <option value="">Select</option>
                                  {filteredSubCategories.map((sc) => <option key={sc.addiction_sub_category_id} value={sc.addiction_sub_category_id}>{sc.addiction_sub_category}</option>)}
                                </select>
                              ) : subCategoryName}</td>
                              <td data-label="Addiction">{isEditing ? <input className="authdata-inline-input" value={editingAddictionData.addictions || ""} onChange={(e) => setEditingAddictionData((p) => ({ ...p, addictions: e.target.value }))} /> : a.addictions}</td>
                              <td data-label="Description">{isEditing ? <input className="authdata-inline-input" value={editingAddictionData.description || ""} onChange={(e) => setEditingAddictionData((p) => ({ ...p, description: e.target.value }))} /> : (a.description || "—")}</td>
                              <td data-label="Clinical Classification">{isEditing ? <input className="authdata-inline-input" value={editingAddictionData.clinical_classification || ""} onChange={(e) => setEditingAddictionData((p) => ({ ...p, clinical_classification: e.target.value }))} /> : (a.clinical_classification || "—")}</td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (<><button type="button" className="btn-action save" onClick={() => handleSaveAddiction(a.addictions_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingAddictionId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditAddiction(a)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteAddiction(a.addictions_id)}>Delete</button></>)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Condition Master */}
              {currentStep === 16 && patientConditions.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patient Conditions</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Patient Condition</th><th>Actions</th></tr></thead>
                      <tbody>
                        {patientConditions.map((pc, i) => (
                          <tr key={pc.patient_condition_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Patient Condition">{editingPatientConditionId === pc.patient_condition_id ? <input className="authdata-inline-input" value={editingPatientConditionValue} onChange={(e) => setEditingPatientConditionValue(e.target.value)} /> : pc.patient_condition}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingPatientConditionId === pc.patient_condition_id ? (<><button type="button" className="btn-action save" onClick={() => handleSavePatientCondition(pc.patient_condition_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingPatientConditionId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditPatientCondition(pc)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeletePatientCondition(pc.patient_condition_id)}>Delete</button></>)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Investigation Type Master */}
              {currentStep === 17 && investigationTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Investigation Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Investigation Type ID</th><th>Investigation Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {investigationTypes.map((it, i) => (
                          <tr key={it.investigation_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Investigation Type ID">{it.investigation_type_id}</td>
                            <td data-label="Investigation Type">{editingInvestigationTypeId === it.investigation_type_id ? <input className="authdata-inline-input" value={editingInvestigationTypeValue} onChange={(e) => setEditingInvestigationTypeValue(e.target.value)} /> : it.investigation_type}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingInvestigationTypeId === it.investigation_type_id ? (<><button type="button" className="btn-action save" onClick={() => handleSaveInvestigationType(it.investigation_type_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingInvestigationTypeId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditInvestigationType(it)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteInvestigationType(it.investigation_type_id)}>Delete</button></>)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Investigation Group Master */}
              {currentStep === 18 && investigationGroups.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Investigation Groups</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Investigation Type</th><th>Investigation Group</th><th>Actions</th></tr></thead>
                      <tbody>
                        {investigationGroups.map((g, i) => {
                          const isEditing = editingInvestigationGroupId === g.investigation_group_id;
                          const typeName = g.investigation_type || investigationTypes.find((it) => String(it.investigation_type_id) === String(g.investigation_type_id))?.investigation_type || "—";
                          return (
                            <tr key={g.investigation_group_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Investigation Type">{isEditing ? (
                                <select className="authdata-inline-input" value={editingInvestigationGroupData.investigation_type_id || ""} onChange={(e) => setEditingInvestigationGroupData((p) => ({ ...p, investigation_type_id: e.target.value }))}>
                                  <option value="">Select</option>{investigationTypes.map((it) => <option key={it.investigation_type_id} value={it.investigation_type_id}>{it.investigation_type}</option>)}
                                </select>
                              ) : typeName}</td>
                              <td data-label="Investigation Group">{isEditing ? <input className="authdata-inline-input" value={editingInvestigationGroupData.investigation_group || ""} onChange={(e) => setEditingInvestigationGroupData((p) => ({ ...p, investigation_group: e.target.value }))} /> : g.investigation_group}</td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (<><button type="button" className="btn-action save" onClick={() => handleSaveInvestigationGroup(g.investigation_group_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingInvestigationGroupId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditInvestigationGroup(g)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteInvestigationGroup(g.investigation_group_id)}>Delete</button></>)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Investigation Master */}
              {currentStep === 19 && investigations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Investigations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th><th>Type</th><th>Group</th><th>Name</th><th>Unit</th>
                          <th>Normal Lo</th><th>Normal Hi</th><th>SOS Lo</th><th>SOS Hi</th><th>Specialties</th><th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {investigations.map((inv, i) => {
                          const isEditing = editingInvestigationId === inv.investigation_id;
                          const d = isEditing ? editingInvestigationData : inv;
                          const specNames = d.medical_specialty_ids
                            ? d.medical_specialty_ids.toString().split(",").map((id) => specialties.find((s) => String(s.medical_specialty_id) === id.trim())?.medical_specialty).filter(Boolean).join(", ")
                            : "—";
                          const inp = (field) => (
                            <input className="authdata-inline-input" value={d[field] ?? ""} onChange={(e) => setEditingInvestigationData((p) => ({ ...p, [field]: e.target.value }))} />
                          );
                          return (
                            <tr key={inv.investigation_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Type">{isEditing ? (
                                <select className="authdata-inline-input" value={d.investigation_type_id || ""} onChange={(e) => setEditingInvestigationData((p) => ({ ...p, investigation_type_id: e.target.value }))}>
                                  <option value="">Select</option>{investigationTypes.map((it) => <option key={it.investigation_type_id} value={it.investigation_type_id}>{it.investigation_type}</option>)}
                                </select>
                              ) : (inv.investigation_type || "—")}</td>
                              <td data-label="Group">{isEditing ? (
                                <select className="authdata-inline-input" value={d.investigation_group_id || ""} onChange={(e) => setEditingInvestigationData((p) => ({ ...p, investigation_group_id: e.target.value }))}>
                                  <option value="">Select</option>{investigationGroups.filter((g) => String(g.investigation_type_id) === String(d.investigation_type_id)).map((g) => <option key={g.investigation_group_id} value={g.investigation_group_id}>{g.investigation_group}</option>)}
                                </select>
                              ) : (inv.investigation_group || "—")}</td>
                              <td data-label="Name">{isEditing ? inp("investigation_name") : inv.investigation_name}</td>
                              <td data-label="Unit">{isEditing ? inp("measurement_unit") : (inv.measurement_unit || "—")}</td>
                              <td data-label="Normal Lo">{isEditing ? inp("normal_range_lower") : (inv.normal_range_lower ?? "—")}</td>
                              <td data-label="Normal Hi">{isEditing ? inp("normal_range_upper") : (inv.normal_range_upper ?? "—")}</td>
                              <td data-label="SOS Lo">{isEditing ? inp("sos_range_lower") : (inv.sos_range_lower ?? "—")}</td>
                              <td data-label="SOS Hi">{isEditing ? inp("sos_range_upper") : (inv.sos_range_upper ?? "—")}</td>
                              <td data-label="Specialties">{specNames || "—"}</td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (<><button type="button" className="btn-action save" onClick={() => handleSaveInvestigation(inv.investigation_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingInvestigationId(null)}>Cancel</button></>) : (<><button type="button" className="btn-action edit" onClick={() => handleEditInvestigation(inv)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteInvestigation(inv.investigation_id)}>Delete</button></>)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Establishment Type Master */}
              {currentStep === 20 && estTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Establishment Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Establishment Type ID</th><th>Establishment Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {estTypes.map((et, i) => (
                          <tr key={et.establishment_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Establishment Type ID">{et.establishment_type_id}</td>
                            <td data-label="Establishment Type">{editingEstId === et.establishment_type_id ? <input className="authdata-inline-input" value={editingEstValue} onChange={(e) => setEditingEstValue(e.target.value)} /> : et.establishment_type}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingEstId === et.establishment_type_id ? (
                                <><button type="button" className="btn-action save" onClick={() => handleSaveEst(et.establishment_type_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingEstId(null)}>Cancel</button></>
                              ) : (
                                <><button type="button" className="btn-action edit" onClick={() => handleEditEst(et)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteEst(et.establishment_type_id)}>Delete</button></>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Establishment Sub Type Master */}
              {currentStep === 21 && establishmentSubTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Establishment Sub Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Establishment Sub Type ID</th>
                          <th>Establishment Type ID</th>
                          <th>Establishment Sub Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {establishmentSubTypes.map((row, i) => {
                          const isEditing = editingEstSubTypeId === row.establishment_sub_type_id;
                          const typeName = row.establishment_type
                            || estTypes.find(
                              (t) => String(t.establishment_type_id) === String(row.establishment_type_id)
                            )?.establishment_type
                            || "—";
                          return (
                            <tr key={row.establishment_sub_type_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Establishment Sub Type ID">{row.establishment_sub_type_id}</td>
                              <td data-label="Establishment Type ID">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingEstSubTypeData.establishment_type_id || ""}
                                    onChange={(e) => setEditingEstSubTypeData((p) => ({
                                      ...p,
                                      establishment_type_id: e.target.value,
                                    }))}
                                  >
                                    <option value="">Select</option>
                                    {estTypes.map((t) => (
                                      <option key={t.establishment_type_id} value={t.establishment_type_id}>
                                        {t.establishment_type}
                                      </option>
                                    ))}
                                  </select>
                                ) : typeName}
                              </td>
                              <td data-label="Establishment Sub Type">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingEstSubTypeData.establishment_sub_type || ""}
                                    onChange={(e) => setEditingEstSubTypeData((p) => ({
                                      ...p,
                                      establishment_sub_type: e.target.value,
                                    }))}
                                  />
                                ) : row.establishment_sub_type}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveEstSubType(row.establishment_sub_type_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingEstSubTypeId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditEstSubType(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteEstSubType(row.establishment_sub_type_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medical Degree Master */}
              {currentStep === 22 && degrees.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medical Degrees</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Medical Degree Title</th><th>Actions</th></tr></thead>
                      <tbody>
                        {degrees.map((d, i) => (
                          <tr key={d.medical_degree_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Medical Degree Title">{editingDegId === d.medical_degree_id ? <input className="authdata-inline-input" value={editingDegValue} onChange={(e) => setEditingDegValue(e.target.value)} /> : d.medical_degree_title}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingDegId === d.medical_degree_id ? (
                                <><button type="button" className="btn-action save" onClick={() => handleSaveDeg(d.medical_degree_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingDegId(null)}>Cancel</button></>
                              ) : (
                                <><button type="button" className="btn-action edit" onClick={() => handleEditDeg(d)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteDeg(d.medical_degree_id)}>Delete</button></>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Specialization Master */}
              {currentStep === 23 && specializations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Specializations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Specialization Type</th><th>Specialization</th><th>Actions</th></tr></thead>
                      <tbody>
                        {specializations.map((s, i) => {
                          const isEditing = editingSpeczId === s.specialization_id;
                          const typeName = s.specialization_type
                            || specializationTypes.find(
                              (st) => String(st.specialization_type_id) === String(s.specialization_type_id)
                            )?.specialization_type
                            || "—";
                          return (
                            <tr key={s.specialization_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Specialization Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingSpeczData.specialization_type_id || ""}
                                    onChange={(e) => setEditingSpeczData((p) => ({ ...p, specialization_type_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {specializationTypes.map((st) => (
                                      <option key={st.specialization_type_id} value={st.specialization_type_id}>
                                        {st.specialization_type}
                                      </option>
                                    ))}
                                  </select>
                                ) : typeName}
                              </td>
                              <td data-label="Specialization">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingSpeczData.specialization || ""}
                                    onChange={(e) => setEditingSpeczData((p) => ({ ...p, specialization: e.target.value }))}
                                  />
                                ) : s.specialization}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <><button type="button" className="btn-action save" onClick={() => handleSaveSpecz(s.specialization_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingSpeczId(null)}>Cancel</button></>
                                ) : (
                                  <><button type="button" className="btn-action edit" onClick={() => handleEditSpecz(s)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteSpecz(s.specialization_id)}>Delete</button></>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {/* List view — Specialization Type Master */}
              {currentStep === 24 && specializationTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Specialization Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Specialization Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {specializationTypes.map((st, i) => (
                          <tr key={st.specialization_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Specialization Type">
                              {editingSpecTypeId === st.specialization_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingSpecTypeValue}
                                  onChange={(e) => setEditingSpecTypeValue(e.target.value)}
                                />
                              ) : st.specialization_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingSpecTypeId === st.specialization_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveSpecType(st.specialization_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingSpecTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditSpecType(st)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteSpecType(st.specialization_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Accreditation Master */}
              {currentStep === 25 && accreditations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Accreditations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Accreditation Title</th><th>Actions</th></tr></thead>
                      <tbody>
                        {accreditations.map((a, i) => (
                          <tr key={a.accreditation_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Accreditation Title">{editingAccrId === a.accreditation_id ? <input className="authdata-inline-input" value={editingAccrValue} onChange={(e) => setEditingAccrValue(e.target.value)} /> : a.accreditation_title}</td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingAccrId === a.accreditation_id ? (
                                <><button type="button" className="btn-action save" onClick={() => handleSaveAccr(a.accreditation_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingAccrId(null)}>Cancel</button></>
                              ) : (
                                <><button type="button" className="btn-action edit" onClick={() => handleEditAccr(a)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteAccr(a.accreditation_id)}>Delete</button></>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Department Type Master */}
              {currentStep === 26 && departmentCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Department Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Department Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {departmentCategories.map((dc, i) => (
                          <tr key={dc.department_category_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Department Type">
                              {editingDeptCatId === dc.department_category_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingDeptCatValue}
                                  onChange={(e) => setEditingDeptCatValue(e.target.value)}
                                />
                              ) : dc.department_category}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingDeptCatId === dc.department_category_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveDeptCat(dc.department_category_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingDeptCatId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditDeptCat(dc)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteDeptCat(dc.department_category_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Hospital Department Master */}
              {currentStep === 27 && departments.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Hospital Departments</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Department Type</th><th>Hospital Department</th><th>Actions</th></tr></thead>
                      <tbody>
                        {departments.map((d, i) => {
                          const isEditing = editingDeptId === d.department_id;
                          const catName = d.department_category
                            || departmentCategories.find(
                              (dc) => String(dc.department_category_id) === String(d.department_category_id)
                            )?.department_category
                            || "—";
                          return (
                            <tr key={d.department_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Department Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingDeptData.department_category_id || ""}
                                    onChange={(e) => setEditingDeptData((p) => ({ ...p, department_category_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {departmentCategories.map((dc) => (
                                      <option key={dc.department_category_id} value={dc.department_category_id}>
                                        {dc.department_category}
                                      </option>
                                    ))}
                                  </select>
                                ) : catName}
                              </td>
                              <td data-label="Hospital Department">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingDeptData.department_name || ""}
                                    onChange={(e) => setEditingDeptData((p) => ({ ...p, department_name: e.target.value }))}
                                  />
                                ) : d.department_name}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveDept(d.department_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingDeptId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditDept(d)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteDept(d.department_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Designation Master */}
              {currentStep === 28 && designations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Designations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Designation</th><th>Actions</th></tr></thead>
                      <tbody>
                        {designations.map((d, i) => (
                          <tr key={d.designation_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Designation">
                              {editingDesigId === d.designation_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingDesigValue}
                                  onChange={(e) => setEditingDesigValue(e.target.value)}
                                />
                              ) : d.designation}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingDesigId === d.designation_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveDesig(d.designation_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingDesigId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditDesig(d)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteDesig(d.designation_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Relationship Master */}
              {currentStep === 46 && relationships.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Relationships</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Relationship</th><th>Actions</th></tr></thead>
                      <tbody>
                        {relationships.map((r, i) => (
                          <tr key={r.relationship_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Relationship">
                              {editingRelationshipId === r.relationship_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingRelationshipValue}
                                  onChange={(e) => setEditingRelationshipValue(e.target.value)}
                                />
                              ) : r.relationship}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingRelationshipId === r.relationship_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveRelationship(r.relationship_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingRelationshipId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditRelationship(r)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteRelationship(r.relationship_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Blood Group Master */}
              {currentStep === 47 && bloodGroups.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Blood Groups</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Blood Group</th><th>Actions</th></tr></thead>
                      <tbody>
                        {bloodGroups.map((bg, i) => (
                          <tr key={bg.blood_group_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Blood Group">
                              {editingBloodGroupId === bg.blood_group_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingBloodGroupValue}
                                  onChange={(e) => setEditingBloodGroupValue(e.target.value)}
                                />
                              ) : bg.blood_group}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingBloodGroupId === bg.blood_group_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveBloodGroup(bg.blood_group_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingBloodGroupId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditBloodGroup(bg)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteBloodGroup(bg.blood_group_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Profile Topic Master */}
              {currentStep === 29 && profileTopics.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Profile Topics</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Profile Topic</th><th>Actions</th></tr></thead>
                      <tbody>
                        {profileTopics.map((pt, i) => (
                          <tr key={pt.profile_topic_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Profile Topic">
                              {editingProfileTopicId === pt.profile_topic_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingProfileTopicValue}
                                  onChange={(e) => setEditingProfileTopicValue(e.target.value)}
                                />
                              ) : pt.profile_topic}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingProfileTopicId === pt.profile_topic_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveProfileTopic(pt.profile_topic_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingProfileTopicId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditProfileTopic(pt)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteProfileTopic(pt.profile_topic_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Profile Sub Topic Master */}
              {currentStep === 30 && profileSubTopics.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Profile Sub Topics</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Profile Topic</th>
                          <th>Profile Sub Topic</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {profileSubTopics.map((st, i) => {
                          const isEditing = editingProfileSubTopicId === st.profile_sub_topic_id;
                          const topicName = st.profile_topic
                            || profileTopics.find(
                              (pt) => String(pt.profile_topic_id) === String(st.profile_topic_id)
                            )?.profile_topic
                            || "—";
                          return (
                            <tr key={st.profile_sub_topic_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Profile Topic">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProfileSubTopicData.profile_topic_id || ""}
                                    onChange={(e) => setEditingProfileSubTopicData((p) => ({ ...p, profile_topic_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {profileTopics.map((pt) => (
                                      <option key={pt.profile_topic_id} value={pt.profile_topic_id}>
                                        {pt.profile_topic}
                                      </option>
                                    ))}
                                  </select>
                                ) : topicName}
                              </td>
                              <td data-label="Profile Sub Topic">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProfileSubTopicData.profile_sub_topic || ""}
                                    onChange={(e) => setEditingProfileSubTopicData((p) => ({ ...p, profile_sub_topic: e.target.value }))}
                                  />
                                ) : st.profile_sub_topic}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveProfileSubTopic(st.profile_sub_topic_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingProfileSubTopicId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditProfileSubTopic(st)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteProfileSubTopic(st.profile_sub_topic_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Service Type Master */}
              {currentStep === 31 && serviceTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Service Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Service Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {serviceTypes.map((st, i) => (
                          <tr key={st.service_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Service Type">
                              {editingServiceTypeId === st.service_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingServiceTypeValue}
                                  onChange={(e) => setEditingServiceTypeValue(e.target.value)}
                                />
                              ) : st.service_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingServiceTypeId === st.service_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveServiceType(st.service_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingServiceTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditServiceType(st)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteServiceType(st.service_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Service Master */}
              {currentStep === 32 && services.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Services</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Service Type</th>
                          <th>Service Title</th>
                          <th>Description</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {services.map((s, i) => {
                          const isEditing = editingServiceId === s.service_id;
                          const typeName = s.service_type
                            || serviceTypes.find(
                              (st) => String(st.service_type_id) === String(s.service_type_id)
                            )?.service_type
                            || "—";
                          return (
                            <tr key={s.service_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Service Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingServiceData.service_type_id || ""}
                                    onChange={(e) => setEditingServiceData((p) => ({ ...p, service_type_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {serviceTypes.map((st) => (
                                      <option key={st.service_type_id} value={st.service_type_id}>
                                        {st.service_type}
                                      </option>
                                    ))}
                                  </select>
                                ) : typeName}
                              </td>
                              <td data-label="Service Title">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingServiceData.service_title || ""}
                                    onChange={(e) => setEditingServiceData((p) => ({ ...p, service_title: e.target.value }))}
                                  />
                                ) : s.service_title}
                              </td>
                              <td data-label="Description">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingServiceData.description || ""}
                                    onChange={(e) => setEditingServiceData((p) => ({ ...p, description: e.target.value }))}
                                  />
                                ) : (s.description || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveService(s.service_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingServiceId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditService(s)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteService(s.service_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Question Type Master */}
              {currentStep === 33 && questionTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Question Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Question Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {questionTypes.map((qt, i) => (
                          <tr key={qt.question_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Question Type">
                              {editingQuestionTypeId === qt.question_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingQuestionTypeValue}
                                  onChange={(e) => setEditingQuestionTypeValue(e.target.value)}
                                />
                              ) : qt.question_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingQuestionTypeId === qt.question_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveQuestionType(qt.question_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingQuestionTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditQuestionType(qt)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteQuestionType(qt.question_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Question Master */}
              {currentStep === 34 && questions.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Questions</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>Question ID</th>
                          <th>Question Linking</th>
                          <th>Linked To</th>
                          <th>Question Type</th>
                          <th>Question Text</th>
                          <th>Description</th>
                          <th>Image</th>
                          <th>Video</th>
                          <th>Video URL</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {questions.map((q) => {
                          const isEditing = editingQuestionId === q.question_id;
                          const row = isEditing ? editingQuestionData : q;
                          const imagePaths = parseImagePaths(row.related_image_paths);
                          return (
                            <tr key={q.question_id}>
                              <td data-label="Question ID">{q.question_id}</td>
                              <td data-label="Question Linking">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={row.question_linking || ""}
                                    onChange={(e) => handleEditingQuestionChange("question_linking", e.target.value)}
                                  >
                                    <option value="">Select</option>
                                    {QUESTION_LINKING_OPTIONS.map((opt) => (
                                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                  </select>
                                ) : (QUESTION_LINKING_LABELS[q.question_linking] || "—")}
                              </td>
                              <td data-label="Linked To">
                                {isEditing ? (
                                  row.question_linking === "profile_topic" ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={row.profile_topic_id || ""}
                                      onChange={(e) => handleEditingQuestionChange("profile_topic_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {profileTopics.map((pt) => (
                                        <option key={pt.profile_topic_id} value={pt.profile_topic_id}>{pt.profile_topic}</option>
                                      ))}
                                    </select>
                                  ) : row.question_linking === "profile_sub_topic" ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={row.profile_sub_topic_id || ""}
                                      onChange={(e) => handleEditingQuestionChange("profile_sub_topic_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {profileSubTopics.map((pst) => (
                                        <option key={pst.profile_sub_topic_id} value={pst.profile_sub_topic_id}>{pst.profile_sub_topic}</option>
                                      ))}
                                    </select>
                                  ) : row.question_linking === "service" ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={row.service_id || ""}
                                      onChange={(e) => handleEditingQuestionChange("service_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {services.map((s) => (
                                        <option key={s.service_id} value={s.service_id}>{s.service_title}</option>
                                      ))}
                                    </select>
                                  ) : "—"
                                ) : getQuestionLinkDisplay(q)}
                              </td>
                              <td data-label="Question Type">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={row.question_type_id || ""}
                                    onChange={(e) => handleEditingQuestionChange("question_type_id", e.target.value)}
                                  >
                                    <option value="">Select</option>
                                    {questionTypes.map((qt) => (
                                      <option key={qt.question_type_id} value={qt.question_type_id}>{qt.question_type}</option>
                                    ))}
                                  </select>
                                ) : (q.question_type || "—")}
                              </td>
                              <td data-label="Question Text">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={row.question_text || ""}
                                    onChange={(e) => handleEditingQuestionChange("question_text", e.target.value)}
                                  />
                                ) : q.question_text}
                              </td>
                              <td data-label="Description">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={row.description || ""}
                                    onChange={(e) => handleEditingQuestionChange("description", e.target.value)}
                                  />
                                ) : (q.description || "—")}
                              </td>
                              <td data-label="Image">
                                {isEditing ? (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={(e) => handleEditingQuestionChange("related_images", e.target.files)}
                                  />
                                ) : imagePaths.length > 0 ? (
                                  <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                                    {imagePaths.map((path) => (
                                      <img
                                        key={path}
                                        src={`${UPLOADS_BASE}/uploads/${path}`}
                                        alt="Related"
                                        style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }}
                                      />
                                    ))}
                                  </div>
                                ) : "—"}
                              </td>
                              <td data-label="Video">
                                {isEditing ? (
                                  <input
                                    type="file"
                                    accept="video/*"
                                    onChange={(e) => handleEditingQuestionChange("video", e.target.files[0])}
                                  />
                                ) : q.video_path ? (
                                  <a href={`${UPLOADS_BASE}/uploads/${q.video_path}`} target="_blank" rel="noreferrer">File</a>
                                ) : "—"}
                              </td>
                              <td data-label="Video URL">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    placeholder="Video URL"
                                    value={row.video_url || ""}
                                    onChange={(e) => handleEditingQuestionChange("video_url", e.target.value)}
                                  />
                                ) : q.video_url ? (
                                  <a href={q.video_url} target="_blank" rel="noreferrer">URL</a>
                                ) : "—"}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveQuestion(q.question_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingQuestionId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditQuestion(q)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteQuestion(q.question_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Option Master */}
              {currentStep === 35 && options.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Options</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Question</th>
                          <th>Sequence</th>
                          <th>Option Text</th>
                          <th>Weightage</th>
                          <th>Table Reference</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {options.map((o, i) => {
                          const isEditing = editingOptionId === o.option_id;
                          const questionText = o.question_text
                            || questions.find(
                              (q) => String(q.question_id) === String(o.question_id)
                            )?.question_text
                            || "—";
                          return (
                            <tr key={o.option_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Question">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingOptionData.question_id || ""}
                                    onChange={(e) => setEditingOptionData((p) => ({ ...p, question_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {questions.map((q) => (
                                      <option key={q.question_id} value={q.question_id}>
                                        {q.question_text}
                                      </option>
                                    ))}
                                  </select>
                                ) : questionText}
                              </td>
                              <td data-label="Sequence">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingOptionData.sequence || ""}
                                    onChange={(e) => setEditingOptionData((p) => ({ ...p, sequence: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {SEQUENCE_OPTIONS.map((n) => (
                                      <option key={n} value={n}>{n}</option>
                                    ))}
                                  </select>
                                ) : o.sequence}
                              </td>
                              <td data-label="Option Text">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingOptionData.option_text || ""}
                                    onChange={(e) => setEditingOptionData((p) => ({ ...p, option_text: e.target.value }))}
                                  />
                                ) : o.option_text}
                              </td>
                              <td data-label="Weightage">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    type="number"
                                    min="1"
                                    max="10"
                                    value={editingOptionData.weightage ?? ""}
                                    onChange={(e) => setEditingOptionData((p) => ({ ...p, weightage: e.target.value }))}
                                  />
                                ) : o.weightage}
                              </td>
                              <td data-label="Table Reference">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingOptionData.table_reference || ""}
                                    onChange={(e) => setEditingOptionData((p) => ({ ...p, table_reference: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {MASTER_TABLE_REFERENCES.map((t) => (
                                      <option key={t.value} value={t.value}>{t.label}</option>
                                    ))}
                                  </select>
                                ) : formatTableReference(o.table_reference)}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveOption(o.option_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingOptionId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditOption(o)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteOption(o.option_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Question Group Master */}
              {currentStep === 36 && questionGroups.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Question Groups</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Profile Sub Topic</th>
                          <th>Service</th>
                          <th>Question Group</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {questionGroups.map((g, i) => {
                          const isEditing = editingQuestionGroupId === g.question_group_id;
                          const subTopicName = g.profile_sub_topic
                            || profileSubTopics.find(
                              (pst) => String(pst.profile_sub_topic_id) === String(g.profile_sub_topic_id)
                            )?.profile_sub_topic
                            || "—";
                          const serviceTitle = g.service_title
                            || services.find(
                              (s) => String(s.service_id) === String(g.service_id)
                            )?.service_title
                            || "—";
                          return (
                            <tr key={g.question_group_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Profile Sub Topic">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingQuestionGroupData.profile_sub_topic_id || ""}
                                    onChange={(e) => setEditingQuestionGroupData((p) => ({ ...p, profile_sub_topic_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {profileSubTopics.map((pst) => (
                                      <option key={pst.profile_sub_topic_id} value={pst.profile_sub_topic_id}>
                                        {pst.profile_sub_topic}
                                      </option>
                                    ))}
                                  </select>
                                ) : subTopicName}
                              </td>
                              <td data-label="Service">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingQuestionGroupData.service_id || ""}
                                    onChange={(e) => setEditingQuestionGroupData((p) => ({ ...p, service_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {services.map((s) => (
                                      <option key={s.service_id} value={s.service_id}>
                                        {s.service_title}
                                      </option>
                                    ))}
                                  </select>
                                ) : serviceTitle}
                              </td>
                              <td data-label="Question Group">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingQuestionGroupData.question_group || ""}
                                    onChange={(e) => setEditingQuestionGroupData((p) => ({ ...p, question_group: e.target.value }))}
                                  />
                                ) : g.question_group}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveQuestionGroup(g.question_group_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingQuestionGroupId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditQuestionGroup(g)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteQuestionGroup(g.question_group_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Establishment Master */}
              {currentStep === 37 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Establishments</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Establishment Type</th>
                          <th>Establishment Sub Type</th>
                          <th>Brand Name</th>
                          <th>Legal Entity Name</th>
                          <th>Est. Year</th>
                          <th>Parent Entity</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {establishments.length === 0 ? (
                          <tr>
                            <td colSpan={8} style={{ textAlign: "center", color: "#6c757d" }}>
                              No establishments saved yet.
                            </td>
                          </tr>
                        ) : (
                          establishments.map((est, i) => {
                            const isEditing = editingEstbId === est.establishment_id;
                            const d = editingEstbData;
                            const set = (field, val) => setEditingEstbData((p) => {
                              const updated = { ...p, [field]: val };
                              if (field === "establishment_type_id") {
                                updated.establishment_sub_type_id = "";
                              }
                              return updated;
                            });
                            const establishmentTypeOptions = normalizeEstablishmentTypes(estTypes);
                            const subTypeOptions = filterEstablishmentSubTypes(
                              establishmentSubTypes,
                              isEditing ? d.establishment_type_id : est.establishment_type_id
                            );

                            const establishmentTypeName = establishmentTypeOptions.find(
                              (t) => String(t.id) === String(est.establishment_type_id)
                            )?.name || est.establishment_type || "—";

                            const subTypeName = subTypeOptions.find(
                              (t) => String(t.id) === String(est.establishment_sub_type_id)
                            )?.name || est.establishment_sub_type || "—";

                            const parentName = est.parent_establishment_name
                              || establishments.find(
                                (e) => String(e.establishment_id) === String(est.parent_establishment_id)
                              )?.establishment_name
                              || "—";

                            const inp = (field, type = "text", extra = {}) => (
                              <input
                                className="authdata-inline-input"
                                type={type}
                                value={d[field] ?? ""}
                                onChange={(e) => set(field, e.target.value)}
                                {...extra}
                              />
                            );

                            return (
                              <tr key={est.establishment_id}>
                                <td data-label="#">{i + 1}</td>
                                <td data-label="Establishment Type">
                                  {isEditing ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={d.establishment_type_id || ""}
                                      onChange={(e) => set("establishment_type_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {establishmentTypeOptions.map((t) => (
                                        <option key={t.id} value={t.id}>
                                          {t.name}
                                        </option>
                                      ))}
                                    </select>
                                  ) : establishmentTypeName}
                                </td>
                                <td data-label="Establishment Sub Type">
                                  {isEditing ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={d.establishment_sub_type_id || ""}
                                      onChange={(e) => set("establishment_sub_type_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {filterEstablishmentSubTypes(establishmentSubTypes, d.establishment_type_id).map((t) => (
                                        <option key={t.id} value={t.id}>
                                          {t.name}
                                        </option>
                                      ))}
                                    </select>
                                  ) : subTypeName}
                                </td>
                                <td data-label="Brand Name">
                                  {isEditing ? inp("establishment_name") : (est.establishment_name || "—")}
                                </td>
                                <td data-label="Legal Entity Name">
                                  {isEditing ? inp("legal_entity_name") : (est.legal_entity_name || "—")}
                                </td>
                                <td data-label="Est. Year">
                                  {isEditing ? inp("establishment_year", "number") : (est.establishment_year || "—")}
                                </td>
                                <td data-label="Parent Entity">
                                  {isEditing ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={d.parent_establishment_id || ""}
                                      onChange={(e) => set("parent_establishment_id", e.target.value)}
                                    >
                                      <option value="">None</option>
                                      {establishments
                                        .filter((e) => e.establishment_id !== est.establishment_id)
                                        .map((e) => (
                                          <option key={e.establishment_id} value={e.establishment_id}>
                                            {e.establishment_name}
                                          </option>
                                        ))}
                                    </select>
                                  ) : parentName}
                                </td>
                                <td className="authdata-actions">
                                  {isEditing ? (
                                    <>
                                      <button type="button" className="btn-action save" onClick={() => handleSaveEstb(est.establishment_id)}>Save</button>
                                      <button type="button" className="btn-action cancel" onClick={() => setEditingEstbId(null)}>Cancel</button>
                                    </>
                                  ) : (
                                    <>
                                      <button type="button" className="btn-action edit" onClick={() => handleEditEstb(est)}>Edit</button>
                                      <button type="button" className="btn-action delete" onClick={() => handleDeleteEstb(est.establishment_id)}>Delete</button>
                                      <button type="button" className="btn-action login" onClick={() => handleOpenCreateLogin(est)}>Create Login</button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Master */}
              {currentStep === 48 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patients</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Patient ID</th>
                          <th>Patient Name</th>
                          <th>Gender</th>
                          <th>Blood Group</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {patients.length === 0 ? (
                          <tr>
                            <td colSpan={8} style={{ textAlign: "center", color: "#6c757d" }}>
                              No patients saved yet.
                            </td>
                          </tr>
                        ) : (
                          patients.map((pat, i) => {
                            const phones = Array.isArray(pat.phone_numbers)
                              ? pat.phone_numbers.filter(Boolean).join(", ")
                              : "—";
                            const isEditing = editingPatientId === pat.patient_id;
                            return (
                              <tr key={pat.patient_id} className={isEditing ? "authdata-row-active" : ""}>
                                <td data-label="#">{i + 1}</td>
                                <td data-label="Patient ID">{pat.patient_id}</td>
                                <td data-label="Patient Name">{pat.patient_name || "—"}</td>
                                <td data-label="Gender">{pat.gender || "—"}</td>
                                <td data-label="Blood Group">{pat.blood_group || "—"}</td>
                                <td data-label="Phone">{phones || "—"}</td>
                                <td data-label="Email">{pat.email_address || "—"}</td>
                                <td data-label="Actions" className="authdata-actions">
                                  <button type="button" className="btn-action edit" onClick={() => handleEditPatient(pat)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeletePatient(pat.patient_id)}>Delete</button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — User Master */}
              {currentStep === 68 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Users</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>User Type</th>
                          <th>Gender</th>
                          <th>Age</th>
                          <th>Phone</th>
                          <th>Country Code</th>
                          <th>Email</th>
                          <th>Country</th>
                          <th>Location</th>
                          <th>Establishment</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.length === 0 ? (
                          <tr>
                            <td colSpan={13} style={{ textAlign: "center", color: "#6c757d" }}>
                              No users saved yet.
                            </td>
                          </tr>
                        ) : (
                          users.map((user, i) => {
                            const isEditing = editingUserId === user.user_id;
                            return (
                              <tr key={user.user_id} className={isEditing ? "authdata-row-active" : ""}>
                                <td data-label="#">{i + 1}</td>
                                <td data-label="User ID">{user.user_id}</td>
                                <td data-label="Name">{user.user_name || "—"}</td>
                                <td data-label="User Type">{user.user_type || "—"}</td>
                                <td data-label="Gender">{user.gender || "—"}</td>
                                <td data-label="Age">{user.age_years ?? "—"}</td>
                                <td data-label="Phone">{user.phone_number || "—"}</td>
                                <td data-label="Country Code">{user.country_code || "—"}</td>
                                <td data-label="Email">{user.email_address || "—"}</td>
                                <td data-label="Country">{user.country_name || "—"}</td>
                                <td data-label="Location">{user.location_name || "—"}</td>
                                <td data-label="Establishment">{user.establishment_name || "—"}</td>
                                <td data-label="Actions" className="authdata-actions">
                                  <button type="button" className="btn-action edit" onClick={() => handleEditUser(user)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteUser(user.user_id)}>Delete</button>
                                  <button type="button" className="btn-action login" onClick={() => handleOpenCreateUserLogin(user)}>Create Login</button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Therapeutic Class Master */}
              {currentStep === 49 && therapeuticClasses.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Therapeutic Classes</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Therapeutic Class</th><th>Actions</th></tr></thead>
                      <tbody>
                        {therapeuticClasses.map((tc, i) => (
                          <tr key={tc.therapeutic_class_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Therapeutic Class">
                              {editingTherapeuticClassId === tc.therapeutic_class_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingTherapeuticClassValue}
                                  onChange={(e) => setEditingTherapeuticClassValue(e.target.value)}
                                />
                              ) : tc.therapeutic_class}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingTherapeuticClassId === tc.therapeutic_class_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveTherapeuticClass(tc.therapeutic_class_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingTherapeuticClassId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditTherapeuticClass(tc)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteTherapeuticClass(tc.therapeutic_class_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medicine Salt Master */}
              {currentStep === 50 && medicineSalts.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medicine Salts</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Therapeutic Class</th>
                          <th>Salt Name</th>
                          <th>Chemical Formula</th>
                          <th>Description</th>
                          <th>Salt Schedule</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medicineSalts.map((ms, i) => {
                          const isEditing = editingMedicineSaltId === ms.salt_id;
                          const className = ms.therapeutic_class || therapeuticClasses.find(
                            (tc) => String(tc.therapeutic_class_id) === String(ms.therapeutic_class_id)
                          )?.therapeutic_class || "—";
                          return (
                            <tr key={ms.salt_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Therapeutic Class">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingMedicineSaltData.therapeutic_class_id || ""}
                                    onChange={(e) => setEditingMedicineSaltData((p) => ({ ...p, therapeutic_class_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {therapeuticClasses.map((tc) => (
                                      <option key={tc.therapeutic_class_id} value={tc.therapeutic_class_id}>
                                        {tc.therapeutic_class}
                                      </option>
                                    ))}
                                  </select>
                                ) : className}
                              </td>
                              <td data-label="Salt Name">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingMedicineSaltData.salt_name || ""}
                                    onChange={(e) => setEditingMedicineSaltData((p) => ({ ...p, salt_name: e.target.value }))}
                                  />
                                ) : ms.salt_name}
                              </td>
                              <td data-label="Chemical Formula">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingMedicineSaltData.chemical_formula || ""}
                                    onChange={(e) => setEditingMedicineSaltData((p) => ({ ...p, chemical_formula: e.target.value }))}
                                  />
                                ) : (ms.chemical_formula || "—")}
                              </td>
                              <td data-label="Description">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingMedicineSaltData.description || ""}
                                    onChange={(e) => setEditingMedicineSaltData((p) => ({ ...p, description: e.target.value }))}
                                  />
                                ) : (ms.description || "—")}
                              </td>
                              <td data-label="Salt Schedule">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingMedicineSaltData.salt_schedule || ""}
                                    onChange={(e) => setEditingMedicineSaltData((p) => ({ ...p, salt_schedule: e.target.value }))}
                                  />
                                ) : (ms.salt_schedule || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveMedicineSalt(ms.salt_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingMedicineSaltId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditMedicineSalt(ms)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteMedicineSalt(ms.salt_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medical Prescription Master */}
              {currentStep === 51 && medicalPrescriptions.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medical Prescriptions</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Case ID</th>
                          <th>Parent Case</th>
                          <th>Patient</th>
                          <th>Date</th>
                          <th>Doctor</th>
                          <th>Establishment</th>
                          <th>Duration</th>
                          <th>Front</th>
                          <th>Back</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medicalPrescriptions.map((rx, i) => {
                          const isEditing = editingMedicalPrescriptionId === rx.prescription_id;
                          const data = isEditing ? editingMedicalPrescriptionData : rx;
                          const filteredCases = patientCases.filter(
                            (c) => !data.patient_id || String(c.patient_id) === String(data.patient_id)
                          );
                          const filteredParentCases = filteredCases.filter(
                            (c) => !data.case_id || String(c.case_id) !== String(data.case_id)
                          );
                          const patientName = rx.patient_name || patients.find(
                            (p) => String(p.patient_id) === String(rx.patient_id)
                          )?.patient_name || "—";
                          const doctorName = rx.doctor_name || doctors.find(
                            (d) => String(d.doctor_id) === String(rx.doctor_id)
                          )?.doctor_name || "—";
                          const establishmentName = rx.establishment_name || establishments.find(
                            (e) => String(e.establishment_id) === String(rx.establishment_id)
                          )?.establishment_name || "—";
                          const renderImage = (path) => (
                            path ? (
                              <a href={`${UPLOADS_BASE}/uploads/${path}`} target="_blank" rel="noreferrer">
                                <img
                                  src={`${UPLOADS_BASE}/uploads/${path}`}
                                  alt="Prescription"
                                  style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 4 }}
                                />
                              </a>
                            ) : "—"
                          );
                          return (
                            <tr key={rx.prescription_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Case ID">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.case_id || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({
                                      ...p,
                                      case_id: e.target.value,
                                      patient_id: patientCases.find((c) => String(c.case_id) === String(e.target.value))?.patient_id || p.patient_id,
                                    }))}
                                  >
                                    <option value="">Select</option>
                                    {filteredCases.map((c) => (
                                      <option key={c.case_id} value={c.case_id}>Case #{c.case_id}</option>
                                    ))}
                                  </select>
                                ) : rx.case_id}
                              </td>
                              <td data-label="Parent Case">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.parent_case_id || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({ ...p, parent_case_id: e.target.value }))}
                                  >
                                    <option value="">None</option>
                                    {filteredParentCases.map((c) => (
                                      <option key={c.case_id} value={c.case_id}>Case #{c.case_id}</option>
                                    ))}
                                  </select>
                                ) : (rx.parent_case_id || "—")}
                              </td>
                              <td data-label="Patient">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.patient_id || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({
                                      ...p,
                                      patient_id: e.target.value,
                                      case_id: "",
                                      parent_case_id: "",
                                    }))}
                                  >
                                    <option value="">Select</option>
                                    {patients.map((p) => (
                                      <option key={p.patient_id} value={p.patient_id}>{p.patient_name}</option>
                                    ))}
                                  </select>
                                ) : patientName}
                              </td>
                              <td data-label="Date">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    type="date"
                                    value={data.prescription_date || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({ ...p, prescription_date: e.target.value }))}
                                  />
                                ) : (rx.prescription_date ? String(rx.prescription_date).slice(0, 10) : "—")}
                              </td>
                              <td data-label="Doctor">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.doctor_id || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({ ...p, doctor_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {doctors.map((d) => (
                                      <option key={d.doctor_id} value={d.doctor_id}>{d.doctor_name}</option>
                                    ))}
                                  </select>
                                ) : doctorName}
                              </td>
                              <td data-label="Establishment">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.establishment_id || ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({ ...p, establishment_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {establishments.map((e) => (
                                      <option key={e.establishment_id} value={e.establishment_id}>{e.establishment_name}</option>
                                    ))}
                                  </select>
                                ) : establishmentName}
                              </td>
                              <td data-label="Duration">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    type="number"
                                    min="1"
                                    value={data.duration_days ?? ""}
                                    onChange={(e) => setEditingMedicalPrescriptionData((p) => ({ ...p, duration_days: e.target.value }))}
                                  />
                                ) : (rx.duration_days ?? "—")}
                              </td>
                              <td data-label="Front">
                                {isEditing ? (
                                  <>
                                    {renderImage(data.prescription_image_front)}
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) => setEditingMedicalPrescriptionData((p) => ({
                                        ...p,
                                        prescription_image_front: e.target.files[0] || p.prescription_image_front,
                                      }))}
                                    />
                                  </>
                                ) : renderImage(rx.prescription_image_front)}
                              </td>
                              <td data-label="Back">
                                {isEditing ? (
                                  <>
                                    {renderImage(data.prescription_image_back)}
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) => setEditingMedicalPrescriptionData((p) => ({
                                        ...p,
                                        prescription_image_back: e.target.files[0] || p.prescription_image_back,
                                      }))}
                                    />
                                  </>
                                ) : renderImage(rx.prescription_image_back)}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveMedicalPrescription(rx.prescription_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingMedicalPrescriptionId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditMedicalPrescription(rx)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteMedicalPrescription(rx.prescription_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Dosage Master */}
              {currentStep === 52 && medicineDosages.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Dosage Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Dosage Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {medicineDosages.map((d, i) => (
                          <tr key={d.dosage_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Dosage Type">
                              {editingMedicineDosageId === d.dosage_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingMedicineDosageValue}
                                  onChange={(e) => setEditingMedicineDosageValue(e.target.value)}
                                />
                              ) : d.dosage_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingMedicineDosageId === d.dosage_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveMedicineDosage(d.dosage_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingMedicineDosageId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditMedicineDosage(d)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteMedicineDosage(d.dosage_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Prescription Medicine Master */}
              {currentStep === 53 && patientPrescriptionMedicines.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patient Prescription Medicines</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Case ID</th>
                          <th>Patient</th>
                          <th>Prescription</th>
                          <th>Salt</th>
                          <th>Dosage</th>
                          <th>Duration</th>
                          <th>Empty Stomach</th>
                          <th>SOS</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {patientPrescriptionMedicines.map((ppm, i) => {
                          const isEditing = editingPatientPrescriptionMedicineId === ppm.patient_prescription_medicine_id;
                          const data = isEditing ? editingPatientPrescriptionMedicineData : ppm;
                          const filteredCases = patientCases.filter(
                            (c) => !data.patient_id || String(c.patient_id) === String(data.patient_id)
                          );
                          const filteredPrescriptions = medicalPrescriptions.filter(
                            (rx) => !data.case_id || String(rx.case_id) === String(data.case_id)
                          );
                          const patientName = ppm.patient_name || patients.find(
                            (p) => String(p.patient_id) === String(ppm.patient_id)
                          )?.patient_name || "—";
                          const saltName = ppm.salt_name || medicineSalts.find(
                            (ms) => String(ms.salt_id) === String(ppm.salt_id)
                          )?.salt_name || "—";
                          const dosageLabel = ppm.dosage_type || medicineDosages.find(
                            (d) => String(d.dosage_id) === String(ppm.dosage_id)
                          )?.dosage_type || "—";
                          return (
                            <tr key={ppm.patient_prescription_medicine_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Case ID">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.case_id || ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({
                                      ...p,
                                      case_id: e.target.value,
                                      prescription_id: "",
                                      patient_id: patientCases.find((c) => String(c.case_id) === String(e.target.value))?.patient_id || p.patient_id,
                                    }))}
                                  >
                                    <option value="">Select</option>
                                    {filteredCases.map((c) => (
                                      <option key={c.case_id} value={c.case_id}>Case #{c.case_id}</option>
                                    ))}
                                  </select>
                                ) : ppm.case_id}
                              </td>
                              <td data-label="Patient">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.patient_id || ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({
                                      ...p,
                                      patient_id: e.target.value,
                                      case_id: "",
                                      prescription_id: "",
                                    }))}
                                  >
                                    <option value="">Select</option>
                                    {patients.map((p) => (
                                      <option key={p.patient_id} value={p.patient_id}>{p.patient_name}</option>
                                    ))}
                                  </select>
                                ) : patientName}
                              </td>
                              <td data-label="Prescription">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.prescription_id || ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, prescription_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {filteredPrescriptions.map((rx) => (
                                      <option key={rx.prescription_id} value={rx.prescription_id}>#{rx.prescription_id}</option>
                                    ))}
                                  </select>
                                ) : `#${ppm.prescription_id}`}
                              </td>
                              <td data-label="Salt">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.salt_id || ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, salt_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {medicineSalts.map((ms) => (
                                      <option key={ms.salt_id} value={ms.salt_id}>{ms.salt_name}</option>
                                    ))}
                                  </select>
                                ) : saltName}
                              </td>
                              <td data-label="Dosage">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.dosage_id || ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, dosage_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {medicineDosages.map((d) => (
                                      <option key={d.dosage_id} value={d.dosage_id}>{d.dosage_type}</option>
                                    ))}
                                  </select>
                                ) : dosageLabel}
                              </td>
                              <td data-label="Duration">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    type="number"
                                    min="0"
                                    value={data.duration_days ?? ""}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, duration_days: e.target.value }))}
                                  />
                                ) : (ppm.duration_days != null ? `${ppm.duration_days} days` : "—")}
                              </td>
                              <td data-label="Empty Stomach">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.is_empty_stomach ?? 0}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, is_empty_stomach: Number(e.target.value) }))}
                                  >
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                  </select>
                                ) : formatYesNo(ppm.is_empty_stomach ? 1 : 0)}
                              </td>
                              <td data-label="SOS">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={data.is_sos ?? 0}
                                    onChange={(e) => setEditingPatientPrescriptionMedicineData((p) => ({ ...p, is_sos: Number(e.target.value) }))}
                                  >
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                  </select>
                                ) : formatYesNo(ppm.is_sos ? 1 : 0)}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSavePatientPrescriptionMedicine(ppm.patient_prescription_medicine_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingPatientPrescriptionMedicineId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditPatientPrescriptionMedicine(ppm)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeletePatientPrescriptionMedicine(ppm.patient_prescription_medicine_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Case Master */}
              {currentStep === 54 && patientCases.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patient Cases</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Patient ID</th>
                          <th>Referring Doctor ID</th>
                          <th>Medical Specialty ID</th>
                          <th>Medical Service Type</th>
                          <th>Case ID</th>
                          <th>Date &amp; Time</th>
                          <th>Comments</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {patientCases.map((pc, i) => {
                          const isEditing = editingPatientCaseId === pc.case_id;
                          const data = isEditing ? editingPatientCaseData : pc;
                          return (
                            <tr key={pc.case_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Patient ID">{pc.patient_id}</td>
                              <td data-label="Referring Doctor ID">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.referring_doctor_id || ""}
                                    onChange={(e) => setEditingPatientCaseData((p) => ({ ...p, referring_doctor_id: e.target.value }))}
                                  >
                                    <option value="">—</option>
                                    {doctors.map((d) => (
                                      <option key={d.doctor_id} value={d.doctor_id}>{d.doctor_id} — {d.doctor_name}</option>
                                    ))}
                                  </select>
                                ) : (pc.referring_doctor_id ?? "—")}
                              </td>
                              <td data-label="Medical Specialty ID">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.medical_specialty_id || ""}
                                    onChange={(e) => setEditingPatientCaseData((p) => ({ ...p, medical_specialty_id: e.target.value }))}
                                  >
                                    <option value="">—</option>
                                    {specialties.map((s) => (
                                      <option key={s.medical_specialty_id} value={s.medical_specialty_id}>
                                        {s.medical_specialty_id} — {s.medical_specialty}
                                      </option>
                                    ))}
                                  </select>
                                ) : (pc.medical_specialty ? `${pc.medical_specialty_id} — ${pc.medical_specialty}` : (pc.medical_specialty_id ?? "—"))}
                              </td>
                              <td data-label="Medical Service Type">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.medical_service_id || ""}
                                    onChange={(e) => setEditingPatientCaseData((p) => ({ ...p, medical_service_id: e.target.value }))}
                                  >
                                    <option value="">—</option>
                                    {medicalServices.map((ms) => (
                                      <option key={ms.medical_service_id} value={ms.medical_service_id}>
                                        {ms.medical_service_id} — {ms.medical_service}
                                      </option>
                                    ))}
                                  </select>
                                ) : (pc.medical_service ? `${pc.medical_service_id} — ${pc.medical_service}` : (pc.medical_service_id ?? "—"))}
                              </td>
                              <td data-label="Case ID">{pc.case_id}</td>
                              <td data-label="Date & Time">
                                {isEditing ? (
                                  <input
                                    type="datetime-local"
                                    className="form-control form-control-sm"
                                    value={data.case_date_time || ""}
                                    onChange={(e) => setEditingPatientCaseData((p) => ({ ...p, case_date_time: e.target.value }))}
                                  />
                                ) : (pc.case_date_time ? new Date(pc.case_date_time).toLocaleString() : "—")}
                              </td>
                              <td data-label="Comments">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.comments || ""}
                                    onChange={(e) => setEditingPatientCaseData((p) => ({ ...p, comments: e.target.value }))}
                                  />
                                ) : (pc.comments || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSavePatientCase(pc.case_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingPatientCaseId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditPatientCase(pc)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeletePatientCase(pc.case_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Medical Services Master */}
              {currentStep === 62 && medicalServices.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Medical Services</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Medical Service ID</th><th>Medical Service</th><th>Actions</th></tr></thead>
                      <tbody>
                        {medicalServices.map((ms, i) => (
                          <tr key={ms.medical_service_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Medical Service ID">{ms.medical_service_id}</td>
                            <td data-label="Medical Service">
                              {editingMedicalServiceId === ms.medical_service_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingMedicalServiceValue}
                                  onChange={(e) => setEditingMedicalServiceValue(e.target.value)}
                                />
                              ) : ms.medical_service}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingMedicalServiceId === ms.medical_service_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveMedicalService(ms.medical_service_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingMedicalServiceId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditMedicalService(ms)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteMedicalService(ms.medical_service_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Complaints */}
              {currentStep === 55 && patientComplaints.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patient Complaints</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Case ID</th>
                          <th>Patient ID</th>
                          <th>Complaint ID</th>
                          <th>Complaint</th>
                          <th>Severity</th>
                          <th>Aggravating Factors</th>
                          <th>Is SOS</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {patientComplaints.map((row, i) => {
                          const isEditing = editingPatientComplaintId === row.patient_complaint_id;
                          const data = isEditing ? editingPatientComplaintData : row;
                          const factorsText = Array.isArray(row.aggravating_factors) && row.aggravating_factors.length
                            ? row.aggravating_factors.join(", ")
                            : "—";
                          return (
                            <tr key={row.patient_complaint_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Case ID">{row.case_id}</td>
                              <td data-label="Patient ID">{row.patient_id}</td>
                              <td data-label="Complaint ID">{row.patient_complaint_id}</td>
                              <td data-label="Complaint">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.complaint || ""}
                                    onChange={(e) => setEditingPatientComplaintData((p) => ({ ...p, complaint: e.target.value }))}
                                  />
                                ) : (row.symptom_name || row.complaint || "—")}
                              </td>
                              <td data-label="Severity">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.severity ?? ""}
                                    onChange={(e) => setEditingPatientComplaintData((p) => ({ ...p, severity: e.target.value }))}
                                  >
                                    <option value="">—</option>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                                      <option key={n} value={n}>{n}</option>
                                    ))}
                                  </select>
                                ) : (row.severity ?? "—")}
                              </td>
                              <td data-label="Aggravating Factors">{factorsText}</td>
                              <td data-label="Is SOS">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.is_sos ? 1 : 0}
                                    onChange={(e) => setEditingPatientComplaintData((p) => ({ ...p, is_sos: Number(e.target.value) === 1 }))}
                                  >
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                  </select>
                                ) : formatYesNo(row.is_sos ? 1 : 0)}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSavePatientComplaint(row)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingPatientComplaintId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditPatientComplaint(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeletePatientComplaint(row)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Case Diagnosis */}
              {currentStep === 56 && caseDiagnoses.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Case Diagnoses</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Case ID</th>
                          <th>Patient ID</th>
                          <th>Diagnosis ID</th>
                          <th>Diagnosis</th>
                          <th>Status</th>
                          <th>Comments</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {caseDiagnoses.map((row, i) => {
                          const isEditing = editingCaseDiagnosisId === row.case_diagnosis_id;
                          const data = isEditing ? editingCaseDiagnosisData : row;
                          return (
                            <tr key={row.case_diagnosis_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Case ID">{row.case_id}</td>
                              <td data-label="Patient ID">{row.patient_id}</td>
                              <td data-label="Diagnosis ID">{row.disease_id ?? "—"}</td>
                              <td data-label="Diagnosis">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.diagnosis || ""}
                                    onChange={(e) => setEditingCaseDiagnosisData((p) => ({ ...p, diagnosis: e.target.value }))}
                                  />
                                ) : (row.disease_name || row.diagnosis || "—")}
                              </td>
                              <td data-label="Status">
                                {isEditing ? (
                                  <select
                                    className="form-select form-select-sm"
                                    value={data.status || "Provisional"}
                                    onChange={(e) => setEditingCaseDiagnosisData((p) => ({ ...p, status: e.target.value }))}
                                  >
                                    <option value="Provisional">Provisional</option>
                                    <option value="Confirmed">Confirmed</option>
                                  </select>
                                ) : (row.status || "—")}
                              </td>
                              <td data-label="Comments">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.comments || ""}
                                    onChange={(e) => setEditingCaseDiagnosisData((p) => ({ ...p, comments: e.target.value }))}
                                  />
                                ) : (row.comments || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveCaseDiagnosis(row)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingCaseDiagnosisId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditCaseDiagnosis(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteCaseDiagnosis(row)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Patient Investigation */}
              {currentStep === 57 && patientInvestigations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Patient Investigations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Case ID</th>
                          <th>Patient ID</th>
                          <th>Diagnosis ID</th>
                          <th>Investigation ID</th>
                          <th>Upload Scan</th>
                          <th>Upload Report</th>
                          <th>Abnormalities</th>
                          <th>Investigation Date</th>
                          <th>Comments</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {patientInvestigations.map((row, i) => {
                          const isEditing = editingPatientInvestigationId === row.patient_investigation_id;
                          const data = isEditing ? editingPatientInvestigationData : row;
                          const abnormalitiesText = Array.isArray(row.abnormalities) && row.abnormalities.length
                            ? row.abnormalities.join(", ")
                            : "—";
                          const renderInvestigationImage = (path) => (
                            path ? (
                              <a href={`${UPLOADS_BASE}/uploads/${path}`} target="_blank" rel="noreferrer">
                                <img
                                  src={`${UPLOADS_BASE}/uploads/${path}`}
                                  alt="Investigation"
                                  style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 4 }}
                                />
                              </a>
                            ) : "—"
                          );
                          return (
                            <tr key={row.patient_investigation_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Case ID">{row.case_id}</td>
                              <td data-label="Patient ID">{row.patient_id}</td>
                              <td data-label="Diagnosis ID">{row.case_diagnosis_id ?? "—"}</td>
                              <td data-label="Investigation ID">{row.investigation_id ?? "—"}</td>
                              <td data-label="Upload Scan">
                                {isEditing ? (
                                  <>
                                    {renderInvestigationImage(data.upload_scan_path)}
                                    <input
                                      type="file"
                                      accept="image/*"
                                      className="form-control form-control-sm mt-1"
                                      onChange={(e) => setEditingPatientInvestigationData((p) => ({
                                        ...p,
                                        upload_scan: e.target.files[0] || p.upload_scan,
                                      }))}
                                    />
                                  </>
                                ) : renderInvestigationImage(row.upload_scan_path)}
                              </td>
                              <td data-label="Upload Report">
                                {isEditing ? (
                                  <>
                                    {renderInvestigationImage(data.upload_report_path)}
                                    <input
                                      type="file"
                                      accept="image/*"
                                      className="form-control form-control-sm mt-1"
                                      onChange={(e) => setEditingPatientInvestigationData((p) => ({
                                        ...p,
                                        upload_report: e.target.files[0] || p.upload_report,
                                      }))}
                                    />
                                  </>
                                ) : renderInvestigationImage(row.upload_report_path)}
                              </td>
                              <td data-label="Abnormalities">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.abnormalities_text || ""}
                                    onChange={(e) => setEditingPatientInvestigationData((p) => ({
                                      ...p,
                                      abnormalities_text: e.target.value,
                                      abnormalities: e.target.value.split(",").map((item) => item.trim()).filter(Boolean),
                                    }))}
                                  />
                                ) : abnormalitiesText}
                              </td>
                              <td data-label="Investigation Date">
                                {isEditing ? (
                                  <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={data.investigation_date || ""}
                                    onChange={(e) => setEditingPatientInvestigationData((p) => ({ ...p, investigation_date: e.target.value }))}
                                  />
                                ) : (row.investigation_date ? String(row.investigation_date).slice(0, 10) : "—")}
                              </td>
                              <td data-label="Comments">
                                {isEditing ? (
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={data.comments || ""}
                                    onChange={(e) => setEditingPatientInvestigationData((p) => ({ ...p, comments: e.target.value }))}
                                  />
                                ) : (row.comments || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSavePatientInvestigation(row)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingPatientInvestigationId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditPatientInvestigation(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeletePatientInvestigation(row)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Doctor Master */}
              {currentStep === 38 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Doctors</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Doctor ID</th>
                          <th>Doctor Name</th>
                          <th>Establishment</th>
                          <th>Speciality</th>
                          <th>Department</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {doctors.length === 0 ? (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center", color: "#6c757d" }}>
                              No doctors saved yet.
                            </td>
                          </tr>
                        ) : (
                          doctors.map((doc, i) => {
                            const isEditing = editingDoctorId === doc.doctor_id;
                            const d = editingDoctorData;
                            const set = (field, val) => setEditingDoctorData((p) => ({ ...p, [field]: val }));
                            const inp = (field, type = "text", extra = {}) => (
                              <input
                                className="authdata-inline-input"
                                type={type}
                                value={d[field] ?? ""}
                                onChange={(e) => set(field, e.target.value)}
                                {...extra}
                              />
                            );

                            return (
                              <tr key={doc.doctor_id}>
                                <td data-label="#">{i + 1}</td>
                                <td data-label="Doctor ID">{doc.doctor_id}</td>
                                <td data-label="Doctor Name">
                                  {isEditing ? inp("doctor_name") : (doc.doctor_name || "—")}
                                </td>
                                <td data-label="Establishment">
                                  {isEditing ? (
                                    <div className="authdata-multi-check">
                                      {establishments.map((est) => {
                                        const selectedIds = String(d.establishment_ids || d.establishment_id || "")
                                          .split(",")
                                          .map((s) => s.trim())
                                          .filter(Boolean);
                                        const checked = selectedIds.includes(String(est.establishment_id));
                                        return (
                                          <label key={est.establishment_id} className="authdata-multi-check__item">
                                            <input
                                              type="checkbox"
                                              checked={checked}
                                              onChange={() => {
                                                const id = String(est.establishment_id);
                                                const next = checked
                                                  ? selectedIds.filter((x) => x !== id)
                                                  : [...selectedIds, id];
                                                set("establishment_ids", next.join(","));
                                                set("establishment_id", next[0] || "");
                                              }}
                                            />
                                            <span>{est.establishment_name}</span>
                                          </label>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    (() => {
                                      const ids = String(doc.establishment_ids || doc.establishment_id || "")
                                        .split(",")
                                        .map((s) => s.trim())
                                        .filter(Boolean);
                                      if (!ids.length) return "—";
                                      const names = ids.map(
                                        (id) =>
                                          establishments.find(
                                            (est) => String(est.establishment_id) === String(id)
                                          )?.establishment_name || `#${id}`
                                      );
                                      return names.join(", ");
                                    })()
                                  )}
                                </td>
                                <td data-label="Speciality">
                                  {isEditing ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={d.medical_specialty_id || ""}
                                      onChange={(e) => set("medical_specialty_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {specialties.map((s) => (
                                        <option key={s.medical_specialty_id} value={s.medical_specialty_id}>
                                          {s.medical_specialty}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (doc.medical_specialty || "—")}
                                </td>
                                <td data-label="Department">
                                  {isEditing ? (
                                    <select
                                      className="authdata-inline-input"
                                      value={d.department_id || ""}
                                      onChange={(e) => set("department_id", e.target.value)}
                                    >
                                      <option value="">Select</option>
                                      {departments.map((dept) => (
                                        <option key={dept.department_id} value={dept.department_id}>
                                          {dept.department_name}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (doc.department_name || "—")}
                                </td>
                                <td data-label="Actions" className="authdata-actions">
                                  {isEditing ? (
                                    <>
                                      <button type="button" className="btn-action save" onClick={() => handleSaveDoctor(doc.doctor_id)}>Save</button>
                                      <button type="button" className="btn-action cancel" onClick={() => setEditingDoctorId(null)}>Cancel</button>
                                    </>
                                  ) : (
                                    <>
                                      <button type="button" className="btn-action edit" onClick={() => handleEditDoctor(doc)}>Edit</button>
                                      <button type="button" className="btn-action delete" onClick={() => handleDeleteDoctor(doc.doctor_id)}>Delete</button>
                                      <button type="button" className="btn-action login" onClick={() => handleOpenCreateDoctorLogin(doc)}>Create Login</button>
                                    </>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Event Type Master */}
              {currentStep === 39 && eventTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Event Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Event Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {eventTypes.map((et, i) => (
                          <tr key={et.event_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Event Type">
                              {editingEventTypeId === et.event_type_id ? (
                                <input
                                  className="authdata-inline-input"
                                  value={editingEventTypeValue}
                                  onChange={(e) => setEditingEventTypeValue(e.target.value)}
                                />
                              ) : et.event_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingEventTypeId === et.event_type_id ? (
                                <>
                                  <button type="button" className="btn-action save" onClick={() => handleSaveEventType(et.event_type_id)}>Save</button>
                                  <button type="button" className="btn-action cancel" onClick={() => setEditingEventTypeId(null)}>Cancel</button>
                                </>
                              ) : (
                                <>
                                  <button type="button" className="btn-action edit" onClick={() => handleEditEventType(et)}>Edit</button>
                                  <button type="button" className="btn-action delete" onClick={() => handleDeleteEventType(et.event_type_id)}>Delete</button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Immunization Master */}
              {currentStep === 41 && immunizations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Immunizations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Immunization ID</th>
                          <th>Immunization Name</th>
                          <th>Immunization Type</th>
                          <th>Applicable Gender</th>
                          <th>Applicable Age Group</th>
                          <th>Applicable Morbidity</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {immunizations.map((imm, i) => {
                          const isEditing = editingImmunizationId === imm.immunization_id;
                          const morbidityName = imm.applicable_morbidity
                            || morbidityDiseases.find(
                              (d) => String(d.disease_id) === String(imm.applicable_morbidity_id)
                            )?.disease_name
                            || "—";
                          const sel = (field, options, labelKey = null) => (
                            <select
                              className="authdata-inline-input"
                              value={editingImmunizationData[field] || ""}
                              onChange={(e) => setEditingImmunizationData((p) => ({ ...p, [field]: e.target.value }))}
                            >
                              <option value="">Select</option>
                              {options.map((opt) => {
                                const val = labelKey ? opt[labelKey] : opt;
                                const key = labelKey ? opt.disease_id : opt;
                                const label = labelKey ? opt.disease_name : opt;
                                return <option key={key} value={val}>{label}</option>;
                              })}
                            </select>
                          );
                          return (
                            <tr key={imm.immunization_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Immunization ID">{imm.immunization_id}</td>
                              <td data-label="Immunization Name">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingImmunizationData.immunization_name || ""}
                                    onChange={(e) => setEditingImmunizationData((p) => ({ ...p, immunization_name: e.target.value }))}
                                  />
                                ) : imm.immunization_name}
                              </td>
                              <td data-label="Immunization Type">
                                {isEditing ? sel("immunization_type", IMMUNIZATION_TYPE_OPTIONS) : imm.immunization_type}
                              </td>
                              <td data-label="Applicable Gender">
                                {isEditing ? sel("applicable_gender", APPLICABLE_GENDER_OPTIONS) : imm.applicable_gender}
                              </td>
                              <td data-label="Applicable Age Group">
                                {isEditing ? sel("applicable_age_group", APPLICABLE_AGE_GROUP_OPTIONS) : imm.applicable_age_group}
                              </td>
                              <td data-label="Applicable Morbidity">
                                {isEditing
                                  ? sel("applicable_morbidity_id", morbidityDiseases, "disease_id")
                                  : morbidityName}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveImmunization(imm.immunization_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingImmunizationId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditImmunization(imm)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteImmunization(imm.immunization_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Immunization Master */}
              {currentStep === 41 && immunizations.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Immunizations</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Immunization ID</th>
                          <th>Immunization Name</th>
                          <th>Immunization Type</th>
                          <th>Applicable Gender</th>
                          <th>Applicable Age Group</th>
                          <th>Applicable Morbidity</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {immunizations.map((imm, i) => {
                          const isEditing = editingImmunizationId === imm.immunization_id;
                          const morbidityName = imm.applicable_morbidity
                            || morbidityDiseases.find(
                              (d) => String(d.disease_id) === String(imm.applicable_morbidity_id)
                            )?.disease_name
                            || "—";
                          const sel = (field, options, labelKey = null) => (
                            <select
                              className="authdata-inline-input"
                              value={editingImmunizationData[field] || ""}
                              onChange={(e) => setEditingImmunizationData((p) => ({ ...p, [field]: e.target.value }))}
                            >
                              <option value="">Select</option>
                              {options.map((opt) => {
                                const val = labelKey ? opt[labelKey] : opt;
                                const key = labelKey ? opt.disease_id : opt;
                                const label = labelKey ? opt.disease_name : opt;
                                return <option key={key} value={val}>{label}</option>;
                              })}
                            </select>
                          );
                          return (
                            <tr key={imm.immunization_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Immunization ID">{imm.immunization_id}</td>
                              <td data-label="Immunization Name">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingImmunizationData.immunization_name || ""}
                                    onChange={(e) => setEditingImmunizationData((p) => ({ ...p, immunization_name: e.target.value }))}
                                  />
                                ) : imm.immunization_name}
                              </td>
                              <td data-label="Immunization Type">
                                {isEditing ? sel("immunization_type", IMMUNIZATION_TYPE_OPTIONS) : imm.immunization_type}
                              </td>
                              <td data-label="Applicable Gender">
                                {isEditing ? sel("applicable_gender", APPLICABLE_GENDER_OPTIONS) : imm.applicable_gender}
                              </td>
                              <td data-label="Applicable Age Group">
                                {isEditing ? sel("applicable_age_group", APPLICABLE_AGE_GROUP_OPTIONS) : imm.applicable_age_group}
                              </td>
                              <td data-label="Applicable Morbidity">
                                {isEditing
                                  ? sel("applicable_morbidity_id", morbidityDiseases, "disease_id")
                                  : morbidityName}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveImmunization(imm.immunization_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingImmunizationId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditImmunization(imm)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteImmunization(imm.immunization_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Vaccine Master */}
              {currentStep === 42 && vaccines.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Vaccines</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Vaccine ID</th>
                          <th>Age Group</th>
                          <th>Gender</th>
                          <th>Vaccine Name</th>
                          <th>Schedule Detail</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vaccines.map((v, i) => {
                          const isEditing = editingVaccineId === v.vaccine_id;
                          const sel = (field, options) => (
                            <select
                              className="authdata-inline-input"
                              value={editingVaccineData[field] || ""}
                              onChange={(e) => setEditingVaccineData((p) => ({ ...p, [field]: e.target.value }))}
                            >
                              <option value="">Select</option>
                              {options.map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          );
                          return (
                            <tr key={v.vaccine_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Vaccine ID">{v.vaccine_id}</td>
                              <td data-label="Age Group">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingVaccineData.age_group || ""}
                                    onChange={(e) => setEditingVaccineData((p) => ({ ...p, age_group: e.target.value }))}
                                  />
                                ) : v.age_group}
                              </td>
                              <td data-label="Gender">
                                {isEditing ? sel("gender", VACCINE_GENDER_OPTIONS) : v.gender}
                              </td>
                              <td data-label="Vaccine Name">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingVaccineData.vaccine_name || ""}
                                    onChange={(e) => setEditingVaccineData((p) => ({ ...p, vaccine_name: e.target.value }))}
                                  />
                                ) : v.vaccine_name}
                              </td>
                              <td data-label="Schedule Detail">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingVaccineData.schedule_detail || ""}
                                    onChange={(e) => setEditingVaccineData((p) => ({ ...p, schedule_detail: e.target.value }))}
                                  />
                                ) : v.schedule_detail}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveVaccine(v.vaccine_id)}>Save</button>
                                    <button type="button" className="btn-action cancel" onClick={() => setEditingVaccineId(null)}>Cancel</button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditVaccine(v)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteVaccine(v.vaccine_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Supplier Type Master */}
              {currentStep === 58 && supplierTypes.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Supplier Types</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Supplier Type ID</th><th>Supplier Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {supplierTypes.map((row, i) => (
                          <tr key={row.supplier_type_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="Supplier Type ID">{row.supplier_type_id}</td>
                            <td data-label="Supplier Type">
                              {editingSupplierTypeId === row.supplier_type_id ? (
                                <input className="authdata-inline-input" value={editingSupplierTypeValue} onChange={(e) => setEditingSupplierTypeValue(e.target.value)} />
                              ) : row.supplier_type}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingSupplierTypeId === row.supplier_type_id ? (
                                <><button type="button" className="btn-action save" onClick={() => handleSaveSupplierType(row.supplier_type_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingSupplierTypeId(null)}>Cancel</button></>
                              ) : (
                                <><button type="button" className="btn-action edit" onClick={() => handleEditSupplierType(row)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteSupplierType(row.supplier_type_id)}>Delete</button></>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Product Category Master */}
              {currentStep === 59 && productCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Product Categories</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Category Code</th>
                          <th>Product Category</th>
                          <th>Category Group</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productCategories.map((row, i) => {
                          const isEditing = editingProductCategoryId === row.product_category_id;
                          return (
                            <tr key={row.product_category_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Category Code">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductCategoryData.category_code || ""}
                                    onChange={(e) => setEditingProductCategoryData((p) => ({ ...p, category_code: e.target.value }))}
                                    placeholder="CAT-01"
                                  />
                                ) : (row.category_code || "—")}
                              </td>
                              <td data-label="Product Category">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductCategoryData.product_category || ""}
                                    onChange={(e) => setEditingProductCategoryData((p) => ({ ...p, product_category: e.target.value }))}
                                  />
                                ) : row.product_category}
                              </td>
                              <td data-label="Category Group">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProductCategoryData.category_group || ""}
                                    onChange={(e) => setEditingProductCategoryData((p) => ({ ...p, category_group: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    <option value="Implants">Implants</option>
                                    <option value="Medical Devices">Medical Devices</option>
                                    <option value="Equipment">Equipment</option>
                                    <option value="Consumables">Consumables</option>
                                    <option value="Hospital Essentials">Hospital Essentials</option>
                                    <option value="Pharmaceuticals">Pharmaceuticals</option>
                                    <option value="Software">Software</option>
                                  </select>
                                ) : (row.category_group || "—")}
                              </td>
                              <td data-label="Status">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProductCategoryData.status || "Active"}
                                    onChange={(e) => setEditingProductCategoryData((p) => ({ ...p, status: e.target.value }))}
                                  >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                ) : (row.status || "Active")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveProductCategory(row.product_category_id)}>Save</button>
                                    <button
                                      type="button"
                                      className="btn-action cancel"
                                      onClick={() => {
                                        setEditingProductCategoryId(null);
                                        setEditingProductCategoryData({});
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditProductCategory(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteProductCategory(row.product_category_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Product Sub Category Master */}
              {currentStep === 60 && productSubCategories.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Product Sub Categories</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Sub Category Code</th>
                          <th>Product Category</th>
                          <th>Product Sub Category</th>
                          <th>Description</th>
                          <th>HSN Code</th>
                          <th>Regulatory Body</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productSubCategories.map((row, i) => {
                          const isEditing = editingProductSubCategoryId === row.product_sub_category_id;
                          return (
                            <tr key={row.product_sub_category_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Sub Category Code">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.sub_category_code || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, sub_category_code: e.target.value }))}
                                    placeholder="SUBCAT-0001"
                                  />
                                ) : (row.sub_category_code || "—")}
                              </td>
                              <td data-label="Product Category">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.product_category_id || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, product_category_id: e.target.value }))}
                                  >
                                    <option value="">Select</option>
                                    {productCategories.map((pc) => (
                                      <option key={pc.product_category_id} value={pc.product_category_id}>
                                        {pc.category_code ? `${pc.category_code} — ${pc.product_category}` : pc.product_category}
                                      </option>
                                    ))}
                                  </select>
                                ) : (row.product_category || "—")}
                              </td>
                              <td data-label="Product Sub Category">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.product_sub_category || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, product_sub_category: e.target.value }))}
                                  />
                                ) : row.product_sub_category}
                              </td>
                              <td data-label="Description">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.sub_category_description || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, sub_category_description: e.target.value }))}
                                  />
                                ) : (row.sub_category_description || "—")}
                              </td>
                              <td data-label="HSN Code">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.hsn_code || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, hsn_code: e.target.value }))}
                                  />
                                ) : (row.hsn_code || "—")}
                              </td>
                              <td data-label="Regulatory Body">
                                {isEditing ? (
                                  <input
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.regulatory_body || ""}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, regulatory_body: e.target.value }))}
                                  />
                                ) : (row.regulatory_body || "—")}
                              </td>
                              <td data-label="Status">
                                {isEditing ? (
                                  <select
                                    className="authdata-inline-input"
                                    value={editingProductSubCategoryData.status || "Active"}
                                    onChange={(e) => setEditingProductSubCategoryData((p) => ({ ...p, status: e.target.value }))}
                                  >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                ) : (row.status || "Active")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <>
                                    <button type="button" className="btn-action save" onClick={() => handleSaveProductSubCategory(row.product_sub_category_id)}>Save</button>
                                    <button
                                      type="button"
                                      className="btn-action cancel"
                                      onClick={() => {
                                        setEditingProductSubCategoryId(null);
                                        setEditingProductSubCategoryData({});
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button type="button" className="btn-action edit" onClick={() => handleEditProductSubCategory(row)}>Edit</button>
                                    <button type="button" className="btn-action delete" onClick={() => handleDeleteProductSubCategory(row.product_sub_category_id)}>Delete</button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — MVT Journey Phase Master */}
              {currentStep === 70 && mvtJourneyPhases.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved MVT Journey Phases</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>MVT Journey Phase ID</th><th>MVT Journey Phase</th><th>Actions</th></tr></thead>
                      <tbody>
                        {mvtJourneyPhases.map((row, i) => (
                          <tr key={row.mvt_journey_phase_id}>
                            <td data-label="#">{i + 1}</td>
                            <td data-label="MVT Journey Phase ID">{row.mvt_journey_phase_id}</td>
                            <td data-label="MVT Journey Phase">
                              {editingMvtJourneyPhaseId === row.mvt_journey_phase_id ? (
                                <input className="authdata-inline-input" value={editingMvtJourneyPhaseValue} onChange={(e) => setEditingMvtJourneyPhaseValue(e.target.value)} />
                              ) : row.mvt_journey_phase}
                            </td>
                            <td data-label="Actions" className="authdata-actions">
                              {editingMvtJourneyPhaseId === row.mvt_journey_phase_id ? (
                                <><button type="button" className="btn-action save" onClick={() => handleSaveMvtJourneyPhase(row.mvt_journey_phase_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingMvtJourneyPhaseId(null)}>Cancel</button></>
                              ) : (
                                <><button type="button" className="btn-action edit" onClick={() => handleEditMvtJourneyPhase(row)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteMvtJourneyPhase(row.mvt_journey_phase_id)}>Delete</button></>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — MVT Journey Steps Master */}
              {currentStep === 71 && mvtJourneySteps.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved MVT Journey Steps</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead><tr><th>#</th><th>Step ID</th><th>MVT Journey Phase</th><th>Step Name</th><th>TAT</th><th>Input Type</th><th>Output Type</th><th>Actions</th></tr></thead>
                      <tbody>
                        {mvtJourneySteps.map((row, i) => {
                          const isEditing = editingMvtJourneyStepId === row.mvt_journey_step_id;
                          return (
                            <tr key={row.mvt_journey_step_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Step ID">{row.mvt_journey_step_id}</td>
                              <td data-label="MVT Journey Phase">
                                {isEditing ? (
                                  <select className="authdata-inline-input" value={editingMvtJourneyStepData.mvt_journey_phase_id || ""} onChange={(e) => setEditingMvtJourneyStepData((p) => ({ ...p, mvt_journey_phase_id: e.target.value }))}>
                                    <option value="">Select</option>
                                    {mvtJourneyPhases.map((p) => (
                                      <option key={p.mvt_journey_phase_id} value={p.mvt_journey_phase_id}>{p.mvt_journey_phase}</option>
                                    ))}
                                  </select>
                                ) : (row.mvt_journey_phase || "—")}
                              </td>
                              <td data-label="Step Name">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={editingMvtJourneyStepData.mvt_journey_step_name || ""} onChange={(e) => setEditingMvtJourneyStepData((p) => ({ ...p, mvt_journey_step_name: e.target.value }))} />
                                ) : row.mvt_journey_step_name}
                              </td>
                              <td data-label="TAT">
                                {isEditing ? (
                                  <input type="number" min="0" className="authdata-inline-input" value={editingMvtJourneyStepData.tat ?? ""} onChange={(e) => setEditingMvtJourneyStepData((p) => ({ ...p, tat: e.target.value }))} />
                                ) : (row.tat ?? "—")}
                              </td>
                              <td data-label="Input Type">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={editingMvtJourneyStepData.input_type || ""} onChange={(e) => setEditingMvtJourneyStepData((p) => ({ ...p, input_type: e.target.value }))} />
                                ) : (row.input_type || "—")}
                              </td>
                              <td data-label="Output Type">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={editingMvtJourneyStepData.output_type || ""} onChange={(e) => setEditingMvtJourneyStepData((p) => ({ ...p, output_type: e.target.value }))} />
                                ) : (row.output_type || "—")}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <><button type="button" className="btn-action save" onClick={() => handleSaveMvtJourneyStep(row.mvt_journey_step_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingMvtJourneyStepId(null)}>Cancel</button></>
                                ) : (
                                  <><button type="button" className="btn-action edit" onClick={() => handleEditMvtJourneyStep(row)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteMvtJourneyStep(row.mvt_journey_step_id)}>Delete</button></>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* List view — Product Master */}
              {currentStep === 61 && products.length > 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Products</h6>
                  <div className="authdata-table-scroll">
                    <table className="authdata-table authdata-table--wide">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product ID</th>
                          <th>Category</th>
                          <th>Sub Category</th>
                          <th>Product Name</th>
                          <th>OEM ID</th>
                          <th>Medical Specialties</th>
                          <th>Est. Price INR</th>
                          <th>Est. Price USD</th>
                          <th>Short Description</th>
                          <th>Status</th>
                          <th>Images</th>
                          <th>Video</th>
                          <th>Profile PDF</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((row, i) => {
                          const isEditing = editingProductId === row.product_id;
                          const data = isEditing ? editingProductData : row;
                          const filteredSubs = productSubCategories.filter(
                            (sc) => !data.product_category_id || String(sc.product_category_id) === String(data.product_category_id)
                          );
                          const images = row.product_images || [];
                          const selectedSpecIds = data.medical_specialty_ids
                            ? data.medical_specialty_ids.toString().split(",").map((s) => s.trim()).filter(Boolean)
                            : [];
                          const specNames = selectedSpecIds
                            .map((id) => specialties.find((s) => String(s.medical_specialty_id) === id)?.medical_specialty)
                            .filter(Boolean)
                            .join(", ");
                          return (
                            <tr key={row.product_id}>
                              <td data-label="#">{i + 1}</td>
                              <td data-label="Product ID">{row.product_id}</td>
                              <td data-label="Category">
                                {isEditing ? (
                                  <select className="authdata-inline-input" value={data.product_category_id || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, product_category_id: e.target.value, product_sub_category_id: "" }))}>
                                    <option value="">Select</option>
                                    {productCategories.map((pc) => (
                                      <option key={pc.product_category_id} value={pc.product_category_id}>{pc.product_category}</option>
                                    ))}
                                  </select>
                                ) : (row.product_category || "—")}
                              </td>
                              <td data-label="Sub Category">
                                {isEditing ? (
                                  <select className="authdata-inline-input" value={data.product_sub_category_id || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, product_sub_category_id: e.target.value }))}>
                                    <option value="">Select</option>
                                    {filteredSubs.map((sc) => (
                                      <option key={sc.product_sub_category_id} value={sc.product_sub_category_id}>{sc.product_sub_category}</option>
                                    ))}
                                  </select>
                                ) : (row.product_sub_category || "—")}
                              </td>
                              <td data-label="Product Name">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={data.product_name || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, product_name: e.target.value }))} />
                                ) : row.product_name}
                              </td>
                              <td data-label="OEM ID">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={data.oem_id || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, oem_id: e.target.value }))} />
                                ) : (row.oem_id || "—")}
                              </td>
                              <td data-label="Medical Specialties">
                                {isEditing ? (
                                  <div className="master-checkbox-list" style={{ height: 140, maxHeight: 140, minWidth: 180 }}>
                                    {specialties.map((s) => {
                                      const strId = String(s.medical_specialty_id);
                                      const checked = selectedSpecIds.includes(strId);
                                      return (
                                        <label key={s.medical_specialty_id} className="form-check" style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, margin: 0 }}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={checked}
                                            onChange={() => {
                                              const updated = checked
                                                ? selectedSpecIds.filter((x) => x !== strId)
                                                : [...selectedSpecIds, strId];
                                              setEditingProductData((p) => ({ ...p, medical_specialty_ids: updated.join(",") }));
                                            }}
                                          />
                                          <span className="form-check-label">{s.medical_specialty}</span>
                                        </label>
                                      );
                                    })}
                                  </div>
                                ) : (specNames || "—")}
                              </td>
                              <td data-label="Est. Price INR">
                                {isEditing ? (
                                  <input className="authdata-inline-input" type="number" step="0.01" min="0" value={data.estimated_price_inr ?? ""} onChange={(e) => setEditingProductData((p) => ({ ...p, estimated_price_inr: e.target.value }))} />
                                ) : (row.estimated_price_inr != null ? row.estimated_price_inr : "—")}
                              </td>
                              <td data-label="Est. Price USD">
                                {isEditing ? (
                                  <input className="authdata-inline-input" type="number" step="0.01" min="0" value={data.estimated_price_usd ?? ""} onChange={(e) => setEditingProductData((p) => ({ ...p, estimated_price_usd: e.target.value }))} />
                                ) : (row.estimated_price_usd != null ? row.estimated_price_usd : "—")}
                              </td>
                              <td data-label="Short Description">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={data.short_description || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, short_description: e.target.value }))} />
                                ) : (row.short_description || "—")}
                              </td>
                              <td data-label="Status">
                                {isEditing ? (
                                  <select className="authdata-inline-input" value={data.status || "Active"} onChange={(e) => setEditingProductData((p) => ({ ...p, status: e.target.value }))}>
                                    {PRODUCT_STATUS_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                                  </select>
                                ) : row.status}
                              </td>
                              <td data-label="Images">
                                {isEditing ? (
                                  <input type="file" accept="image/*" multiple className="form-control form-control-sm" onChange={(e) => setEditingProductData((p) => ({ ...p, product_image_files: Array.from(e.target.files || []) }))} />
                                ) : images.length > 0 ? (
                                  <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                                    {images.map((img) => (
                                      <img key={img.product_image_id || img.image_path} src={`${UPLOADS_BASE}/uploads/${img.image_path}`} alt="" style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4 }} />
                                    ))}
                                  </div>
                                ) : "—"}
                              </td>
                              <td data-label="Video">
                                {isEditing ? (
                                  <input className="authdata-inline-input" value={data.product_video_url || ""} onChange={(e) => setEditingProductData((p) => ({ ...p, product_video_url: e.target.value }))} />
                                ) : row.product_video_url ? (
                                  <a href={row.product_video_url} target="_blank" rel="noreferrer">Link</a>
                                ) : "—"}
                              </td>
                              <td data-label="Profile PDF">
                                {isEditing ? (
                                  <input type="file" accept="application/pdf,.pdf" className="form-control form-control-sm" onChange={(e) => setEditingProductData((p) => ({ ...p, product_profile: e.target.files?.[0] || null }))} />
                                ) : row.product_profile_pdf_path ? (
                                  <a href={`${UPLOADS_BASE}/uploads/${row.product_profile_pdf_path}`} target="_blank" rel="noreferrer">PDF</a>
                                ) : "—"}
                              </td>
                              <td data-label="Actions" className="authdata-actions">
                                {isEditing ? (
                                  <><button type="button" className="btn-action save" onClick={() => handleSaveProduct(row.product_id)}>Save</button><button type="button" className="btn-action cancel" onClick={() => setEditingProductId(null)}>Cancel</button></>
                                ) : (
                                  <><button type="button" className="btn-action edit" onClick={() => handleEditProduct(row)}>Edit</button><button type="button" className="btn-action delete" onClick={() => handleDeleteProduct(row.product_id)}>Delete</button></>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {currentStep === 61 && products.length === 0 && (
                <div className="authdata-listview">
                  <h6 className="authdata-listview-title">Saved Products</h6>
                  <p className="text-muted mb-0">
                    No products loaded. Save a product above, or refresh if the API was temporarily unavailable.
                  </p>
                </div>
              )}

    </>
  );
};
